/* This file is generated by scripts/generate-onboarding-engine.mts. Do not edit it by hand. */

export const onboardingContract = {
  "schemaVersion": 1,
  "source": {
    "beats": "src/components/flow-designer/beatsSource.ts#BEATS_SOURCE"
  },
  "provenance": {
    "sourceCommit": "a65bedad5c753e4c6966b6aa3aa0f0d30f43983b",
    "branch": "render-completeness",
    "buildSha": "82fcf3ef7b4b87810668584f0467f862770cf6ecccd26054fcd59161a6ed4db1",
    "artifactHash": "5ece2b0d2689b39d0b4981c9fe760a6fe30131058851a7b66f636ec4873e0fe9"
  },
  "generatedAt": "2026-07-13T15:15:26+03:00",
  "idMap": {
    "screens": {
      "COACH-GREETING": "coach-greeting",
      "ONBOARD-AUTH--FORM": "sign-up",
      "MIC-PERMISSION": "mic-permission",
      "ONBOARD-01--FORM": "profile-greeting",
      "ONBOARD-01--FORM--ASKS": "profile-asks",
      "ONBOARD-STATE-CHECK": "state-check",
      "ONBOARD-MORNING-SETUP": "checkin",
      "ONBOARD-BEGINNER-07": "reflection",
      "ONBOARD-FORK--FORM": "fork",
      "ONBOARD-BEGINNER-01": "category-women",
      "ONBOARD-BEGINNER-02--SLEEP": "goals-sleep",
      "ONBOARD-BEGINNER-02--MOVE": "goals-move",
      "ONBOARD-BEGINNER-02--EAT": "goals-eat",
      "ONBOARD-BEGINNER-02--ENERGY": "goals-energy",
      "ONBOARD-BEGINNER-02--STRESS": "goals-stress",
      "ONBOARD-BEGINNER-02--FOCUS": "goals-focus",
      "ONBOARD-BEGINNER-02--BREAK": "goals-break",
      "ONBOARD-BEGINNER-02--ORGANIZE": "goals-organize",
      "ONBOARD-BEGINNER-02-CUSTOM": "goal-custom",
      "ONBOARD-BEGINNER-03": "habits",
      "ONBOARD-BEGINNER-03--FALL-ASLEEP-EARLIER": "habits-fall-asleep-earlier",
      "ONBOARD-BEGINNER-03--WAKE-EARLIER": "habits-wake-earlier",
      "ONBOARD-BEGINNER-03--SLEEP-CONSISTENTLY": "habits-sleep-consistently",
      "ONBOARD-BEGINNER-03--SLEEP-DEEPLY": "habits-sleep-deeply",
      "ONBOARD-BEGINNER-03--WALK-MORE": "habits-walk-more",
      "ONBOARD-BEGINNER-03--EXERCISE-CONSISTENTLY": "habits-exercise-consistently",
      "ONBOARD-BEGINNER-03--MOBILITY": "habits-mobility",
      "ONBOARD-BEGINNER-03--EAT-INTENTIONALLY": "habits-eat-intentionally",
      "ONBOARD-BEGINNER-03--REDUCE-OVEREATING": "habits-reduce-overeating",
      "ONBOARD-BEGINNER-03--PLAN-FOOD": "habits-plan-food",
      "ONBOARD-BEGINNER-03--MORNING-ENERGY": "habits-morning-energy",
      "ONBOARD-BEGINNER-03--AVOID-CRASHES": "habits-avoid-crashes",
      "ONBOARD-BEGINNER-03--STABLE-ENERGY": "habits-stable-energy",
      "ONBOARD-BEGINNER-03--CALMER-DAY": "habits-calmer-day",
      "ONBOARD-BEGINNER-03--EVENING-STRESS": "habits-evening-stress",
      "ONBOARD-BEGINNER-03--LESS-OVERWHELMED": "habits-less-overwhelmed",
      "ONBOARD-BEGINNER-03--START-WORK": "habits-start-work",
      "ONBOARD-BEGINNER-03--DEEPER-WORK": "habits-deeper-work",
      "ONBOARD-BEGINNER-03--PROCRASTINATE-LESS": "habits-procrastinate-less",
      "ONBOARD-BEGINNER-03--SMOKING": "habits-smoking",
      "ONBOARD-BEGINNER-03--WEED": "habits-weed",
      "ONBOARD-BEGINNER-03--ALCOHOL": "habits-alcohol",
      "ONBOARD-BEGINNER-03--PORN": "habits-porn",
      "ONBOARD-BEGINNER-03--PHONE-USE": "habits-phone-use",
      "ONBOARD-BEGINNER-03--LATE-SNACKING": "habits-late-snacking",
      "ONBOARD-BEGINNER-03--CAFFEINE": "habits-caffeine",
      "ONBOARD-BEGINNER-03--STAY-ON-TASKS": "habits-stay-on-tasks",
      "ONBOARD-BEGINNER-03--TIDY-SPACES": "habits-tidy-spaces",
      "ONBOARD-BEGINNER-03--LIFE-ADMIN": "habits-life-admin",
      "ONBOARD-BEGINNER-03-CUSTOM": "habit-custom",
      "ONBOARD-BEGINNER-04": "schedule",
      "ONBOARD-ADVANCED": "advanced-capture",
      "ONBOARD-ADVANCED-FREQUENCY": "advanced-frequency",
      "ONBOARD-COMPLETE": "plan",
      "ONBOARD-WEEKLY-PROJECTION-BLANK": "weekly-blank",
      "ONBOARD-WEEKLY-PROJECTION-FULL": "weekly-full",
      "ONBOARD-WEEKLY-PROJECTION-P78": "weekly-p78",
      "ONBOARD-WEEKLY-PROJECTION-P36": "weekly-p36",
      "ONBOARD-WEEKLY-PROJECTION-GAPS": "weekly-gaps"
    },
    "clips": {
      "coach_greeting": "/voice/coach_greeting.mp3",
      "mic_permission_1": "/voice/ob/mic_permission_1.wav",
      "onboard_01_form_1": "/voice/ob/onboard_01_form_1.wav",
      "onboard_01_form_2": "/voice/ob/onboard_01_form_2.wav",
      "onboard_state_check_1": "/voice/ob/onboard_state_check_1.wav",
      "state_sleep": "/voice/ob/state_sleep.wav",
      "state_mood": "/voice/ob/state_mood.wav",
      "state_energy": "/voice/ob/state_energy.wav",
      "state_stress": "/voice/ob/state_stress.wav",
      "onboard_morning_setup_1": "/voice/ob/onboard_morning_setup_1.wav",
      "onboard_morning_setup_2": "/voice/ob/onboard_morning_setup_2.wav",
      "onboard_beginner_07_1": "/voice/ob/onboard_beginner_07_1.wav",
      "reflect_proud": "/voice/ob/reflect_proud.wav",
      "reflect_forgive": "/voice/ob/reflect_forgive.wav",
      "reflect_grateful": "/voice/ob/reflect_grateful.wav",
      "reflect_alt": "/voice/ob/reflect_alt.wav",
      "reflect_time": "/voice/ob/reflect_time.wav",
      "onboard_fork_form_1": "/voice/ob/onboard_fork_form_1.wav",
      "fork_question": "/voice/ob/fork_question.wav",
      "onboard_beginner_01_1": "/voice/ob/onboard_beginner_01_1.wav",
      "create_your_own": "/voice/ob/create_your_own.wav",
      "onboard_beginner_02_sleep": "/voice/ob/onboard_beginner_02_sleep.wav",
      "onboard_beginner_02_move": "/voice/ob/onboard_beginner_02_move.wav",
      "onboard_beginner_02_eat": "/voice/ob/onboard_beginner_02_eat.wav",
      "onboard_beginner_02_energy": "/voice/ob/onboard_beginner_02_energy.wav",
      "onboard_beginner_02_stress": "/voice/ob/onboard_beginner_02_stress.wav",
      "onboard_beginner_02_focus": "/voice/ob/onboard_beginner_02_focus.wav",
      "onboard_beginner_02_break": "/voice/ob/onboard_beginner_02_break.wav",
      "onboard_beginner_02_organize": "/voice/ob/onboard_beginner_02_organize.wav",
      "onboard_beginner_02_custom_1": "/voice/ob/onboard_beginner_02_custom_1.wav",
      "onboard_beginner_03_1": "/voice/ob/onboard_beginner_03_1.wav",
      "onboard_beginner_03_goal_fall_asleep_earlier": "/voice/ob/onboard_beginner_03_goal_fall_asleep_earlier.wav",
      "onboard_beginner_03_goal_wake_earlier": "/voice/ob/onboard_beginner_03_goal_wake_earlier.wav",
      "onboard_beginner_03_goal_sleep_consistently": "/voice/ob/onboard_beginner_03_goal_sleep_consistently.wav",
      "onboard_beginner_03_goal_sleep_deeply": "/voice/ob/onboard_beginner_03_goal_sleep_deeply.wav",
      "onboard_beginner_03_goal_walk_more": "/voice/ob/onboard_beginner_03_goal_walk_more.wav",
      "onboard_beginner_03_goal_exercise_consistently": "/voice/ob/onboard_beginner_03_goal_exercise_consistently.wav",
      "onboard_beginner_03_goal_mobility": "/voice/ob/onboard_beginner_03_goal_mobility.wav",
      "onboard_beginner_03_goal_eat_intentionally": "/voice/ob/onboard_beginner_03_goal_eat_intentionally.wav",
      "onboard_beginner_03_goal_reduce_overeating": "/voice/ob/onboard_beginner_03_goal_reduce_overeating.wav",
      "onboard_beginner_03_goal_plan_food": "/voice/ob/onboard_beginner_03_goal_plan_food.wav",
      "onboard_beginner_03_goal_morning_energy": "/voice/ob/onboard_beginner_03_goal_morning_energy.wav",
      "onboard_beginner_03_goal_avoid_crashes": "/voice/ob/onboard_beginner_03_goal_avoid_crashes.wav",
      "onboard_beginner_03_goal_stable_energy": "/voice/ob/onboard_beginner_03_goal_stable_energy.wav",
      "onboard_beginner_03_goal_calmer_day": "/voice/ob/onboard_beginner_03_goal_calmer_day.wav",
      "onboard_beginner_03_goal_evening_stress": "/voice/ob/onboard_beginner_03_goal_evening_stress.wav",
      "onboard_beginner_03_goal_less_overwhelmed": "/voice/ob/onboard_beginner_03_goal_less_overwhelmed.wav",
      "onboard_beginner_03_goal_start_work": "/voice/ob/onboard_beginner_03_goal_start_work.wav",
      "onboard_beginner_03_goal_deeper_work": "/voice/ob/onboard_beginner_03_goal_deeper_work.wav",
      "onboard_beginner_03_goal_procrastinate_less": "/voice/ob/onboard_beginner_03_goal_procrastinate_less.wav",
      "onboard_beginner_03_goal_smoking": "/voice/ob/onboard_beginner_03_goal_smoking.wav",
      "onboard_beginner_03_goal_weed": "/voice/ob/onboard_beginner_03_goal_weed.wav",
      "onboard_beginner_03_goal_alcohol": "/voice/ob/onboard_beginner_03_goal_alcohol.wav",
      "onboard_beginner_03_goal_porn": "/voice/ob/onboard_beginner_03_goal_porn.wav",
      "onboard_beginner_03_goal_phone_use": "/voice/ob/onboard_beginner_03_goal_phone_use.wav",
      "onboard_beginner_03_goal_late_snacking": "/voice/ob/onboard_beginner_03_goal_late_snacking.wav",
      "onboard_beginner_03_goal_caffeine": "/voice/ob/onboard_beginner_03_goal_caffeine.wav",
      "onboard_beginner_03_goal_stay_on_tasks": "/voice/ob/onboard_beginner_03_goal_stay_on_tasks.wav",
      "onboard_beginner_03_goal_tidy_spaces": "/voice/ob/onboard_beginner_03_goal_tidy_spaces.wav",
      "onboard_beginner_03_goal_life_admin": "/voice/ob/onboard_beginner_03_goal_life_admin.wav",
      "onboard_beginner_03_custom_1": "/voice/ob/onboard_beginner_03_custom_1.wav",
      "onboard_beginner_04_1": "/voice/ob/onboard_beginner_04_1.wav",
      "onboard_beginner_04_2": "/voice/ob/onboard_beginner_04_2.wav",
      "onboard_advanced_1": "/voice/ob/onboard_advanced_1.wav",
      "close": "/voice/ob/close.wav",
      "onboard_advanced_frequency_days": "/voice/ob/onboard_advanced_frequency_days.wav",
      "onboard_advanced_frequency_1": "/voice/ob/onboard_advanced_frequency_1.wav",
      "onboard_advanced_frequency_2": "/voice/ob/onboard_advanced_frequency_2.wav",
      "onboard_complete_1": "/voice/ob/onboard_complete_1.wav",
      "onboard_weekly_projection_blank_1": "/voice/ob/onboard_weekly_projection_blank_1.wav",
      "onboard_weekly_projection_full_1": "/voice/ob/onboard_weekly_projection_full_1.wav",
      "onboard_weekly_projection_p78_1": "/voice/ob/onboard_weekly_projection_p78_1.wav",
      "onboard_weekly_projection_p36_1": "/voice/ob/onboard_weekly_projection_p36_1.wav",
      "onboard_weekly_projection_gaps_1": "/voice/ob/onboard_weekly_projection_gaps_1.wav"
    }
  },
  "beats": [
    {
      "id": "splash",
      "order": 0,
      "screenId": null,
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "splash",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [],
      "opener": null,
      "voiceEngine": "Silent",
      "voiceMode": null,
      "context": null,
      "allowedTools": [],
      "persistence": {
        "writes": [],
        "reads": []
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the splash displays on cold start, then the flow proceeds to get-started"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to get-started (order 1)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": []
      },
      "assets": {
        "clips": []
      }
    },
    {
      "id": "get-started",
      "order": 1,
      "screenId": null,
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "get-started",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [],
      "opener": null,
      "voiceEngine": "Silent",
      "voiceMode": null,
      "context": null,
      "allowedTools": [],
      "persistence": {
        "writes": [],
        "reads": []
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the user taps Get started"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to coach-greeting (order 2)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": []
      },
      "assets": {
        "clips": []
      }
    },
    {
      "id": "coach-greeting",
      "order": 2,
      "screenId": "COACH-GREETING",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "splash-intro",
        "props": null,
        "config": {
          "hideOrb": true
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Hey, I might have startled you. You're probably not used to an app just talking to you. I'm your AI coach here at your service at Guided Growth, and I'm excited to help you improve things in your life that are important to you. So let's get you in, and we'll get started.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-1",
            "screen": "COACH-GREETING"
          },
          "voice": "mp3",
          "clipPath": "/voice/coach_greeting.mp3"
        }
      ],
      "opener": "Hey, I might have startled you. You're probably not used to an app just talking to you. I'm your AI coach here at your service at Guided Growth, and I'm excited to help you improve things in your life that are important to you. So let's get you in, and we'll get started.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "First hello. The orb blooms and the coach speaks for the first time: one warm recorded line that lands the surprise of a real voice and invites the user in. Then the flow auto-advances. No component, no user turn, nothing saved.",
      "allowedTools": [],
      "persistence": {
        "writes": [],
        "reads": []
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "auto-advances when the greeting clip ends"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to sign-up"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "audio fails to play",
            "behavior": "show the greeting as text and still auto-advance; never strand the user on a silent screen",
            "voice": null
          },
          {
            "edge": "user speaks over the greeting",
            "behavior": "there is no capture here; ignore input and let the greeting finish, then advance",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "coach_greeting",
            "clipPath": "/voice/coach_greeting.mp3"
          }
        ]
      }
    },
    {
      "id": "sign-up",
      "order": 3,
      "screenId": "ONBOARD-AUTH--FORM",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "auth-signup",
        "props": null,
        "config": {
          "hideOrb": true
        },
        "elements": []
      },
      "script": [],
      "opener": null,
      "voiceEngine": "Silent",
      "voiceMode": null,
      "context": "Auth. The user signs up or logs in by tapping Apple, Google, or email; this is also where their name is captured. The coach stays silent: no greeting, no narration, no tool call. The flow advances on its own once the user is authenticated.",
      "allowedTools": [],
      "persistence": {
        "writes": [
          {
            "key": "profile.name",
            "writtenBy": "auth sign-up"
          },
          {
            "key": "session",
            "writtenBy": null
          }
        ],
        "reads": []
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "a valid authenticated session is established"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to mic-permission"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "auth cancelled",
            "behavior": "user backs out of the provider sheet: stay on the beat, do not advance, no coach line",
            "voice": null
          },
          {
            "edge": "auth error",
            "behavior": "provider returns an error: keep the sign-in options visible for a retry; never advance on failure",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": []
      }
    },
    {
      "id": "mic-permission",
      "order": 4,
      "screenId": "MIC-PERMISSION",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "mic-permission",
        "props": {
          "heading": "Allow your microphone",
          "sub": "So you can talk with your coach out loud."
        },
        "config": {
          "hideOrb": true
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "I'd love to actually talk with you. If you let me use your mic, you can just speak.",
          "bindsTo": {
            "kind": "component",
            "element": "opener-line",
            "screen": "MIC-PERMISSION"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/mic_permission_1.wav"
        }
      ],
      "opener": "I'd love to actually talk with you. If you let me use your mic, you can just speak.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Mic permission. Ask for the mic so the user can talk to the coach. Keep it light, optional, no pressure. If the user skips it, they can still type, and that is completely fine.",
      "allowedTools": [],
      "persistence": {
        "writes": [
          {
            "key": "device.micGranted",
            "writtenBy": null
          }
        ],
        "reads": []
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the user taps Allow or Not now; either choice advances the flow"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to profile-greeting"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "permission granted",
            "behavior": "user taps Allow: the mic is enabled and the flow advances; no coach line needed",
            "voice": null
          },
          {
            "edge": "permission denied / skip",
            "behavior": "user taps Not now: reassure that typing is fine, then advance — \"That's completely fine, you can just type.\" Never pressure or re-ask.",
            "voice": "clip-family:onboard_mic_permission_edge_2 (pending recording)"
          },
          {
            "edge": "permission blocked at OS level",
            "behavior": "the OS has permanently denied the mic: do not loop the prompt; fall back to typing and advance",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "mic_permission_1",
            "clipPath": "/voice/ob/mic_permission_1.wav"
          }
        ]
      }
    },
    {
      "id": "profile-greeting",
      "order": 5,
      "screenId": "ONBOARD-01--FORM",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "profile-beat",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Good to meet you, {name}. Two quick things so I can tailor this to you.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-01--FORM"
          },
          "voice": "cartesia",
          "clipPath": null
        }
      ],
      "opener": "Good to meet you, {name}. Two quick things so I can tailor this to you.",
      "voiceEngine": "Cartesia",
      "voiceMode": "Verbatim",
      "context": "Profile greeting. The coach already knows the user name from sign-in. Greet them by name, warmly, and set up the two quick things about to be collected (age and gender). This beat is only the greeting, spoken live in their name. The asks come next.",
      "allowedTools": [],
      "persistence": {
        "writes": [],
        "reads": [
          {
            "key": "profile.name"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "auto-advances when the greeting clip ends"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to profile-asks (order 6)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "name missing from state",
            "behavior": "if the {name} slot is empty (unexpected), fall back to a name-free warm greeting rather than speaking an empty slot; still auto-advance",
            "voice": null
          },
          {
            "edge": "audio fails to play",
            "behavior": "show the greeting as text and still auto-advance; never strand the user on a silent screen",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": []
      }
    },
    {
      "id": "profile-asks",
      "order": 6,
      "screenId": "ONBOARD-01--FORM--ASKS",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "profile-beat",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": [
          "age",
          "gender"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "How old are you?",
          "bindsTo": {
            "kind": "component",
            "element": "age",
            "screen": "ONBOARD-01--FORM--ASKS"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_01_form_1.wav"
        },
        {
          "seq": 2,
          "speaker": "coach",
          "words": "What's your gender?",
          "bindsTo": {
            "kind": "component",
            "element": "gender",
            "screen": "ONBOARD-01--FORM--ASKS"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_01_form_2.wav"
        }
      ],
      "opener": "How old are you?",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Profile. Collect two things: age and gender. Ask gender plainly and never let the user skip or decline it. Accept voice or taps. If they give one, ask for the other. Both are required before moving on, gender included. Ask for nothing else.",
      "allowedTools": [
        "submit_profile",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "profile.age",
            "writtenBy": "submit_profile"
          },
          {
            "key": "profile.gender",
            "writtenBy": "submit_profile"
          }
        ],
        "reads": []
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_profile fired with both age and gender, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "gender selects the category art variant downstream (Female -> women-art category)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_profile errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" with entries retained. Voice path: one short coach line \"That didn't go through, let me try again.\"",
            "voice": "clip-family:onboard_profile_asks_edge_1 (pending recording)"
          },
          {
            "edge": "invalid age",
            "behavior": "nonsense age: one light redirect, do not store, re-ask plainly once",
            "voice": null
          },
          {
            "edge": "declines gender",
            "behavior": "do not accept a skip; re-ask gender plainly; never advance without it",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_01_form_1",
            "clipPath": "/voice/ob/onboard_01_form_1.wav"
          },
          {
            "clip": "onboard_01_form_2",
            "clipPath": "/voice/ob/onboard_01_form_2.wav"
          }
        ]
      }
    },
    {
      "id": "state-check",
      "order": 7,
      "screenId": "ONBOARD-STATE-CHECK",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "state-check",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "I'd like to invite you into a coaching process. It's built on a few small pieces we'll go through together. Here's the first, a quick state check-in, and I'd like you to do it right now.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-1",
            "screen": "ONBOARD-STATE-CHECK"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_state_check_1.wav"
        },
        {
          "seq": 2,
          "speaker": "coach",
          "words": "How's your sleep?",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-1",
            "screen": "ONBOARD-STATE-CHECK"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/state_sleep.wav"
        },
        {
          "seq": 3,
          "speaker": "coach",
          "words": "How's your mood?",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-2",
            "screen": "ONBOARD-STATE-CHECK"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/state_mood.wav"
        },
        {
          "seq": 4,
          "speaker": "coach",
          "words": "How's your energy?",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-3",
            "screen": "ONBOARD-STATE-CHECK"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/state_energy.wav"
        },
        {
          "seq": 5,
          "speaker": "coach",
          "words": "How's your stress?",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-4",
            "screen": "ONBOARD-STATE-CHECK"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/state_stress.wav"
        }
      ],
      "opener": "I'd like to invite you into a coaching process. It's built on a few small pieces we'll go through together. Here's the first, a quick state check-in, and I'd like you to do it right now.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Check-in (opener for the whole process, plus the first state check). The opener frames the coaching process as a few small pieces done together, built light for everyone, each part explained as it is reached. Then the first piece: a quick state check-in done now. The four questions (sleep, mood, energy, stress) are asked once, each blooming its card; the same cards are the check-in the user fills. Give no advice on what they report; one warm line, then move on.",
      "allowedTools": [
        "record_checkin",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "checkin.state",
            "writtenBy": "record_checkin"
          }
        ],
        "reads": []
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the four state cards are filled, then record_checkin and advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to the morning check-in setup (order 8)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "record_checkin errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" with the ratings retained. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_state_check_edge_1 (pending recording)"
          },
          {
            "edge": "user reports something heavy",
            "behavior": "if the user shares something hard, drop the check-in, be human first, name it plainly, and do not rush them back (global glob-crisis)",
            "voice": null
          },
          {
            "edge": "skips a card",
            "behavior": "a card left unrated: prompt once for the missing one; do not advance until all four are filled",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_state_check_1",
            "clipPath": "/voice/ob/onboard_state_check_1.wav"
          },
          {
            "clip": "state_sleep",
            "clipPath": "/voice/ob/state_sleep.wav"
          },
          {
            "clip": "state_mood",
            "clipPath": "/voice/ob/state_mood.wav"
          },
          {
            "clip": "state_energy",
            "clipPath": "/voice/ob/state_energy.wav"
          },
          {
            "clip": "state_stress",
            "clipPath": "/voice/ob/state_stress.wav"
          }
        ]
      }
    },
    {
      "id": "checkin",
      "order": 8,
      "screenId": "ONBOARD-MORNING-SETUP",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "morning-checkin-setup",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Part of the coaching process is doing this on your workdays. It gives us two things. First, it's a real quick check-in on how your state is, which is valuable, and people don't usually do it enough. And second, over time it lets us see the connection between your behavior and your state. So when would you like to do this each morning? I recommend 15 minutes after you wake up.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-1",
            "screen": "ONBOARD-MORNING-SETUP"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_morning_setup_1.wav"
        },
        {
          "seq": 2,
          "speaker": "coach",
          "words": "",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-1",
            "screen": "ONBOARD-MORNING-SETUP"
          },
          "voice": "mp3",
          "clipPath": null
        },
        {
          "seq": 3,
          "speaker": "coach",
          "words": "",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-2",
            "screen": "ONBOARD-MORNING-SETUP"
          },
          "voice": "mp3",
          "clipPath": null
        },
        {
          "seq": 4,
          "speaker": "coach",
          "words": "",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-3",
            "screen": "ONBOARD-MORNING-SETUP"
          },
          "voice": "mp3",
          "clipPath": null
        },
        {
          "seq": 5,
          "speaker": "coach",
          "words": "Every day is great, but doing it on weekdays consistently beats doing it every day only occasionally. That's what I recommend to start.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-3",
            "screen": "ONBOARD-MORNING-SETUP"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_morning_setup_2.wav"
        }
      ],
      "opener": "Part of the coaching process is doing this on your workdays. It gives us two things. First, it's a real quick check-in on how your state is, which is valuable, and people don't usually do it enough. And second, over time it lets us see the connection between your behavior and your state. So when would you like to do this each morning? I recommend 15 minutes after you wake up.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Check-in time. The user just did their first check-in. Now set its time and locale-driven work-week days, reminder ON by default. Quick. The point is not that it is morning, it is that this is their first habit and it is simple. Recommend a time shortly after wake, offer the local work-week preset, and let them set it. Israel defaults to Sunday through Thursday; everywhere else defaults to Monday through Friday.",
      "allowedTools": [
        "submit_morning_checkin",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "checkin.config",
            "writtenBy": "submit_morning_checkin"
          }
        ],
        "reads": []
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_morning_checkin fired with a time and days, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to the evening reflection setup (order 9)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_morning_checkin errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" with the time retained. Voice path: one short coach line \"That didn't go through, let me try again.\"",
            "voice": "clip-family:onboard_morning_setup_edge_1 (pending recording)"
          },
          {
            "edge": "no time set",
            "behavior": "prompt once for the time; do not advance until a time is set",
            "voice": null
          },
          {
            "edge": "wants reminder off",
            "behavior": "honor it: turn the reminder off if the user asks; default stays ON otherwise",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_morning_setup_1",
            "clipPath": "/voice/ob/onboard_morning_setup_1.wav"
          },
          {
            "clip": "onboard_morning_setup_2",
            "clipPath": "/voice/ob/onboard_morning_setup_2.wav"
          }
        ]
      }
    },
    {
      "id": "reflection",
      "order": 9,
      "screenId": "ONBOARD-BEGINNER-07",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "reflection-card",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "One more. An evening reflection, a minute and a half to close out your day. Use these three questions.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-1",
            "screen": "ONBOARD-BEGINNER-07"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_07_1.wav"
        },
        {
          "seq": 2,
          "speaker": "coach",
          "words": "What am I proud of?",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-1",
            "screen": "ONBOARD-BEGINNER-07"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/reflect_proud.wav"
        },
        {
          "seq": 3,
          "speaker": "coach",
          "words": "What do I forgive myself for?",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-2",
            "screen": "ONBOARD-BEGINNER-07"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/reflect_forgive.wav"
        },
        {
          "seq": 4,
          "speaker": "coach",
          "words": "What am I grateful for?",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-3",
            "screen": "ONBOARD-BEGINNER-07"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/reflect_grateful.wav"
        },
        {
          "seq": 5,
          "speaker": "coach",
          "words": "Or make your own, or just talk freely.",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-4",
            "screen": "ONBOARD-BEGINNER-07"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/reflect_alt.wav"
        },
        {
          "seq": 6,
          "speaker": "coach",
          "words": "",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-5",
            "screen": "ONBOARD-BEGINNER-07"
          },
          "voice": "mp3",
          "clipPath": null
        },
        {
          "seq": 7,
          "speaker": "coach",
          "words": "I'd recommend doing this before bed, maybe 15 minutes before you wind down.",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-6",
            "screen": "ONBOARD-BEGINNER-07"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/reflect_time.wav"
        },
        {
          "seq": 8,
          "speaker": "coach",
          "words": "",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-7",
            "screen": "ONBOARD-BEGINNER-07"
          },
          "voice": "mp3",
          "clipPath": null
        }
      ],
      "opener": "One more. An evening reflection, a minute and a half to close out your day. Use these three questions.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Evening reflection setup. Set it up, do not perform it now. The user picks one style and a time, reminder on by default. Its days default to the locale-driven work week, with weekends off: Israel is Sunday through Thursday, everywhere else is Monday through Friday. The three styles are on the screen (suggested template, your template, freeform); do not read them out. Ask which feels right and let them pick. If they choose your template, capture their prompts verbatim so the evening reflection can ask them back. Add no coaching per style and do not make it feel like homework.",
      "allowedTools": [
        "submit_reflection_config",
        "submit_custom_prompts",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "reflection.config",
            "writtenBy": "submit_reflection_config"
          },
          {
            "key": "reflection.customPrompts",
            "writtenBy": "submit_custom_prompts"
          }
        ],
        "reads": []
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_reflection_config fired with a style and time, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to the path fork (order 10)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_reflection_config errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" with the style retained. Voice path: one short coach line \"That didn't go through, let me try again.\"",
            "voice": "clip-family:onboard_beginner_07_edge_1 (pending recording)"
          },
          {
            "edge": "no style picked",
            "behavior": "prompt once for which style feels right; do not advance until a style is set",
            "voice": null
          },
          {
            "edge": "your-template chosen but no prompts given",
            "behavior": "ask once for at least one prompt; capture verbatim; do not invent prompts for them",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_07_1",
            "clipPath": "/voice/ob/onboard_beginner_07_1.wav"
          },
          {
            "clip": "reflect_proud",
            "clipPath": "/voice/ob/reflect_proud.wav"
          },
          {
            "clip": "reflect_forgive",
            "clipPath": "/voice/ob/reflect_forgive.wav"
          },
          {
            "clip": "reflect_grateful",
            "clipPath": "/voice/ob/reflect_grateful.wav"
          },
          {
            "clip": "reflect_alt",
            "clipPath": "/voice/ob/reflect_alt.wav"
          },
          {
            "clip": "reflect_time",
            "clipPath": "/voice/ob/reflect_time.wav"
          }
        ]
      }
    },
    {
      "id": "fork",
      "order": 10,
      "screenId": "ONBOARD-FORK--FORM",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "path-selection",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "One more question before we set up your habits.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-1",
            "screen": "ONBOARD-FORK--FORM"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_fork_form_1.wav"
        },
        {
          "seq": 2,
          "speaker": "coach",
          "words": "Do you already track habits or is this new to you?",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-1",
            "screen": "ONBOARD-FORK--FORM"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/fork_question.wav"
        },
        {
          "seq": 3,
          "speaker": "coach",
          "words": "",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-2",
            "screen": "ONBOARD-FORK--FORM"
          },
          "voice": "mp3",
          "clipPath": null
        }
      ],
      "opener": "One more question before we set up your habits.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Experience fork. The framing shows as one coach bubble. Then, as the two path cards appear, the fork question is spoken verbal only. New, tried and dropped off, or wants guidance routes to beginner. Has a list or a system already routes to advanced. If unclear, ask one short question. Do not read the two choices out loud, and add no reassurance tail.",
      "allowedTools": [
        "submit_path_choice",
        "ask_clarification",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "flow.path",
            "writtenBy": "submit_path_choice"
          }
        ],
        "reads": []
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_path_choice fired with beginner or advanced, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "beginner -> category (order 11); advanced -> advanced-capture (order 54)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_path_choice errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" with the choice retained. Voice path: one short coach line \"That didn't go through, let me try again.\"",
            "voice": "clip-family:onboard_fork_form_edge_1 (pending recording)"
          },
          {
            "edge": "ambiguous answer",
            "behavior": "one short clarifying question (ask_clarification), then take the answer; never guess the path",
            "voice": null
          },
          {
            "edge": "off-topic input",
            "behavior": "acknowledge briefly, steer back with the fork question, do not advance",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_fork_form_1",
            "clipPath": "/voice/ob/onboard_fork_form_1.wav"
          },
          {
            "clip": "fork_question",
            "clipPath": "/voice/ob/fork_question.wav"
          }
        ]
      }
    },
    {
      "id": "category",
      "order": 11,
      "screenId": "ONBOARD-BEGINNER-01",
      "variantOf": null,
      "path": "beginner",
      "component": {
        "key": "category-grid",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Let's choose one area of your life that you'd like to improve on. Here are our recommended categories.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-1",
            "screen": "ONBOARD-BEGINNER-01"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_01_1.wav"
        },
        {
          "seq": 2,
          "speaker": "coach",
          "words": "",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-8",
            "screen": "ONBOARD-BEGINNER-01"
          },
          "voice": "mp3",
          "clipPath": null
        },
        {
          "seq": 3,
          "speaker": "coach",
          "words": "Or you can create your own.",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-9",
            "screen": "ONBOARD-BEGINNER-01"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/create_your_own.wav"
        }
      ],
      "opener": "Let's choose one area of your life that you'd like to improve on. Here are our recommended categories.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Focus area. Collect one category. The opener shows as a coach bubble, then the category tiles appear (default illustration set). When the create-your-own option appears at the end, \"Or you can create your own\" is spoken verbal only. Ask what they most want to work on, then wait. If they name several, ask which feels most urgent. Keep the response specific to their pick.",
      "allowedTools": [
        "submit_category",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.category",
            "writtenBy": "submit_category"
          }
        ],
        "reads": [
          {
            "key": "profile.gender"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_category fired with a valid single category, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "create-your-own tile -> goal-custom (order 21); any of the 8 canonical categories -> the matching goals-* beat by category (e.g. Sleep better -> goals-sleep, order 13)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_category errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked category stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_category_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "acknowledge briefly, steer back with one short pointer question, do not advance",
            "voice": null
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not choose: falls to the plain one-line re-ask and the tap path (max-turns behavior, no brainstorm; copy-decisions 2026-07-10), never force",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no tiles appeared for the user: ask one neutral question (\"Is anything coming up for you to pick from?\"), do NOT recite the category list to fill the silence",
            "voice": "clip-family:onboard_category_edge_4 (pending recording)"
          },
          {
            "edge": "names two",
            "behavior": "ask which feels most urgent, then take the one",
            "voice": null
          },
          {
            "edge": "names something off-list",
            "behavior": "route to the create-your-own tile / custom category",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_01_1",
            "clipPath": "/voice/ob/onboard_beginner_01_1.wav"
          },
          {
            "clip": "create_your_own",
            "clipPath": "/voice/ob/create_your_own.wav"
          }
        ]
      }
    },
    {
      "id": "category-women",
      "order": 12,
      "screenId": "ONBOARD-BEGINNER-01",
      "variantOf": "category",
      "path": "beginner",
      "component": {
        "key": "category-grid",
        "props": {
          "variant": "female"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Let's choose one area of your life that you'd like to improve on. Here are our recommended categories.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-1",
            "screen": "ONBOARD-BEGINNER-01"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_01_1.wav"
        },
        {
          "seq": 2,
          "speaker": "coach",
          "words": "",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-8",
            "screen": "ONBOARD-BEGINNER-01"
          },
          "voice": "mp3",
          "clipPath": null
        },
        {
          "seq": 3,
          "speaker": "coach",
          "words": "Or you can create your own.",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-9",
            "screen": "ONBOARD-BEGINNER-01"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/create_your_own.wav"
        }
      ],
      "opener": "Let's choose one area of your life that you'd like to improve on. Here are our recommended categories.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Focus area. Collect one category. The opener shows as a coach bubble, then the category tiles appear (women-art illustration set). When the create-your-own option appears at the end, \"Or you can create your own\" is spoken verbal only. Ask what they most want to work on, then wait. If they name several, ask which feels most urgent. Keep the response specific to their pick.",
      "allowedTools": [
        "submit_category",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.category",
            "writtenBy": "submit_category"
          }
        ],
        "reads": [
          {
            "key": "profile.gender"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_category fired with a valid single category, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "create-your-own tile -> goal-custom (order 21); any of the 8 canonical categories -> the matching goals-* beat by category (e.g. Sleep better -> goals-sleep, order 13)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_category errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked category stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_category_women_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "acknowledge briefly, steer back with one short pointer question, do not advance",
            "voice": null
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not choose: falls to the plain one-line re-ask and the tap path (max-turns behavior, no brainstorm; copy-decisions 2026-07-10), never force",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no tiles appeared for the user: ask one neutral question (\"Is anything coming up for you to pick from?\"), do NOT recite the category list to fill the silence",
            "voice": "clip-family:onboard_category_women_edge_4 (pending recording)"
          },
          {
            "edge": "names two",
            "behavior": "ask which feels most urgent, then take the one",
            "voice": null
          },
          {
            "edge": "names something off-list",
            "behavior": "route to the create-your-own tile / custom category",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_01_1",
            "clipPath": "/voice/ob/onboard_beginner_01_1.wav"
          },
          {
            "clip": "create_your_own",
            "clipPath": "/voice/ob/create_your_own.wav"
          }
        ]
      }
    },
    {
      "id": "goals-sleep",
      "order": 13,
      "screenId": "ONBOARD-BEGINNER-02--SLEEP",
      "variantOf": null,
      "path": "beginner",
      "component": {
        "key": "goals-list",
        "props": {
          "category": "Sleep better"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Awesome that you started with sleep. When your sleep is solid, almost everything else gets easier, your mood, your patience, your focus. Strong place to begin, and I'm glad you did. Which of these would you like to start with? Pick one or two.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-02--SLEEP"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_02_sleep.wav"
        }
      ],
      "opener": "Awesome that you started with sleep. When your sleep is solid, almost everything else gets easier, your mood, your patience, your focus. Strong place to begin, and I'm glad you did. Which of these would you like to start with? Pick one or two.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Goals inside the chosen category (Sleep better). The opener reacts warmly to the category and asks for goals in one merged moment, then the Goals tiles appear. Collect one or two goals. Map what the user says to the exact on-screen label; if they speak generally, map to the closest one or ask one short question. One or two, no more. The goal count sets up the downstream habit distribution. Do not read the tiles out loud, do not coach or explain per goal, do not allow more than two.",
      "allowedTools": [
        "submit_goals",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.goals",
            "writtenBy": "submit_goals"
          }
        ],
        "reads": [
          {
            "key": "onboarding.category"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_goals fired with 1 to 2 valid goals, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "the goal count sets up the habit distribution: two goals -> the next beat gives one habit per goal; one goal -> the next beat allows one or two habits. Each picked goal routes to its matching habits-* opener (e.g. Fall asleep earlier -> habits-fall-asleep-earlier)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_goals errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked tiles stay selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_goals_sleep_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the goal question (\"Which of these feels right to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_goals_sleep_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not choose: falls to the plain one-line re-ask and the tap path (max-turns behavior, no brainstorm; copy-decisions 2026-07-10), never force a pick",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no tiles appeared for the user: ask one neutral question (\"Is anything coming up for you to pick from?\"), do NOT recite the goal list to fill the silence",
            "voice": "clip-family:onboard_goals_sleep_edge_4 (pending recording)"
          },
          {
            "edge": "names three",
            "behavior": "ask which two matter most, then take those two",
            "voice": null
          },
          {
            "edge": "vague / general (\"just sleep in general\")",
            "behavior": "map to the closest label or ask one short question to pin it (\"If you had to pick one, what bothers you most?\"); never invent a label",
            "voice": "clip-family:onboard_goals_sleep_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_02_sleep",
            "clipPath": "/voice/ob/onboard_beginner_02_sleep.wav"
          }
        ]
      }
    },
    {
      "id": "goals-move",
      "order": 14,
      "screenId": "ONBOARD-BEGINNER-02--MOVE",
      "variantOf": "goals-sleep",
      "path": "beginner",
      "component": {
        "key": "goals-list",
        "props": {
          "category": "Move more"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Love that you chose this. Movement is one of those things where a little goes a long way, and I think you're going to feel the difference faster than you'd expect. Which of these would you like to start with? Pick one or two.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-02--MOVE"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_02_move.wav"
        }
      ],
      "opener": "Love that you chose this. Movement is one of those things where a little goes a long way, and I think you're going to feel the difference faster than you'd expect. Which of these would you like to start with? Pick one or two.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Goals inside the chosen category (Move more). The opener reacts warmly to the category and asks for goals in one merged moment, then the Goals tiles appear. Collect one or two goals. Map what the user says to the exact on-screen label; if they speak generally, map to the closest one or ask one short question. One or two, no more. The goal count sets up the downstream habit distribution. Do not read the tiles out loud, do not coach or explain per goal, do not allow more than two.",
      "allowedTools": [
        "submit_goals",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.goals",
            "writtenBy": "submit_goals"
          }
        ],
        "reads": [
          {
            "key": "onboarding.category"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_goals fired with 1 to 2 valid goals, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "the goal count sets up the habit distribution: two goals -> the next beat gives one habit per goal; one goal -> the next beat allows one or two habits. Each picked goal routes to its matching habits-* opener (e.g. Walk more -> habits-walk-more)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_goals errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked tiles stay selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_goals_move_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the goal question (\"Which of these feels right to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_goals_move_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not choose: falls to the plain one-line re-ask and the tap path (max-turns behavior, no brainstorm; copy-decisions 2026-07-10), never force a pick",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no tiles appeared for the user: ask one neutral question (\"Is anything coming up for you to pick from?\"), do NOT recite the goal list to fill the silence",
            "voice": "clip-family:onboard_goals_move_edge_4 (pending recording)"
          },
          {
            "edge": "names three",
            "behavior": "ask which two matter most, then take those two",
            "voice": null
          },
          {
            "edge": "vague / general (\"just moving more in general\")",
            "behavior": "map to the closest label or ask one short question to pin it (\"If you had to pick one, what bothers you most?\"); never invent a label",
            "voice": "clip-family:onboard_goals_move_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_02_move",
            "clipPath": "/voice/ob/onboard_beginner_02_move.wav"
          }
        ]
      }
    },
    {
      "id": "goals-eat",
      "order": 15,
      "screenId": "ONBOARD-BEGINNER-02--EAT",
      "variantOf": "goals-sleep",
      "path": "beginner",
      "component": {
        "key": "goals-list",
        "props": {
          "category": "Eat better"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "I'm happy you went with this one. Food is something you touch every single day, so it's a place where small changes really add up, and I'm excited to help you find yours. Which of these would you like to start with? Pick one or two.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-02--EAT"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_02_eat.wav"
        }
      ],
      "opener": "I'm happy you went with this one. Food is something you touch every single day, so it's a place where small changes really add up, and I'm excited to help you find yours. Which of these would you like to start with? Pick one or two.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Goals inside the chosen category (Eat better). The opener reacts warmly to the category and asks for goals in one merged moment, then the Goals tiles appear. Collect one or two goals. Map what the user says to the exact on-screen label; if they speak generally, map to the closest one or ask one short question. One or two, no more. The goal count sets up the downstream habit distribution. Do not read the tiles out loud, do not coach or explain per goal, do not allow more than two.",
      "allowedTools": [
        "submit_goals",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.goals",
            "writtenBy": "submit_goals"
          }
        ],
        "reads": [
          {
            "key": "onboarding.category"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_goals fired with 1 to 2 valid goals, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "the goal count sets up the habit distribution: two goals -> the next beat gives one habit per goal; one goal -> the next beat allows one or two habits. Each picked goal routes to its matching habits-* opener (e.g. Eat more intentionally -> habits-eat-intentionally)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_goals errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked tiles stay selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_goals_eat_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the goal question (\"Which of these feels right to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_goals_eat_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not choose: falls to the plain one-line re-ask and the tap path (max-turns behavior, no brainstorm; copy-decisions 2026-07-10), never force a pick",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no tiles appeared for the user: ask one neutral question (\"Is anything coming up for you to pick from?\"), do NOT recite the goal list to fill the silence",
            "voice": "clip-family:onboard_goals_eat_edge_4 (pending recording)"
          },
          {
            "edge": "names three",
            "behavior": "ask which two matter most, then take those two",
            "voice": null
          },
          {
            "edge": "vague / general (\"just eating better in general\")",
            "behavior": "map to the closest label or ask one short question to pin it (\"If you had to pick one, what bothers you most?\"); never invent a label",
            "voice": "clip-family:onboard_goals_eat_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_02_eat",
            "clipPath": "/voice/ob/onboard_beginner_02_eat.wav"
          }
        ]
      }
    },
    {
      "id": "goals-energy",
      "order": 16,
      "screenId": "ONBOARD-BEGINNER-02--ENERGY",
      "variantOf": "goals-sleep",
      "path": "beginner",
      "component": {
        "key": "goals-list",
        "props": {
          "category": "Feel more energized"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "This is a great one to choose. More energy changes how every part of your day feels, and I'm excited for what that could open up for you. Which of these would you like to start with? Pick one or two.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-02--ENERGY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_02_energy.wav"
        }
      ],
      "opener": "This is a great one to choose. More energy changes how every part of your day feels, and I'm excited for what that could open up for you. Which of these would you like to start with? Pick one or two.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Goals inside the chosen category (Feel more energized). The opener reacts warmly to the category and asks for goals in one merged moment, then the Goals tiles appear. Collect one or two goals. Map what the user says to the exact on-screen label; if they speak generally, map to the closest one or ask one short question. One or two, no more. The goal count sets up the downstream habit distribution. Do not read the tiles out loud, do not coach or explain per goal, do not allow more than two.",
      "allowedTools": [
        "submit_goals",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.goals",
            "writtenBy": "submit_goals"
          }
        ],
        "reads": [
          {
            "key": "onboarding.category"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_goals fired with 1 to 2 valid goals, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "the goal count sets up the habit distribution: two goals -> the next beat gives one habit per goal; one goal -> the next beat allows one or two habits. Each picked goal routes to its matching habits-* opener (e.g. Have more morning energy -> habits-morning-energy)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_goals errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked tiles stay selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_goals_energy_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the goal question (\"Which of these feels right to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_goals_energy_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not choose: falls to the plain one-line re-ask and the tap path (max-turns behavior, no brainstorm; copy-decisions 2026-07-10), never force a pick",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no tiles appeared for the user: ask one neutral question (\"Is anything coming up for you to pick from?\"), do NOT recite the goal list to fill the silence",
            "voice": "clip-family:onboard_goals_energy_edge_4 (pending recording)"
          },
          {
            "edge": "names three",
            "behavior": "ask which two matter most, then take those two",
            "voice": null
          },
          {
            "edge": "vague / general (\"just more energy in general\")",
            "behavior": "map to the closest label or ask one short question to pin it (\"If you had to pick one, what bothers you most?\"); never invent a label",
            "voice": "clip-family:onboard_goals_energy_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_02_energy",
            "clipPath": "/voice/ob/onboard_beginner_02_energy.wav"
          }
        ]
      }
    },
    {
      "id": "goals-stress",
      "order": 17,
      "screenId": "ONBOARD-BEGINNER-02--STRESS",
      "variantOf": "goals-sleep",
      "path": "beginner",
      "component": {
        "key": "goals-list",
        "props": {
          "category": "Reduce stress"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "I'm really glad you chose this. Giving your stress somewhere to go is one of the kindest things you can do for yourself, and I'd love to help you build that. Which of these would you like to start with? Pick one or two.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-02--STRESS"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_02_stress.wav"
        }
      ],
      "opener": "I'm really glad you chose this. Giving your stress somewhere to go is one of the kindest things you can do for yourself, and I'd love to help you build that. Which of these would you like to start with? Pick one or two.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Goals inside the chosen category (Reduce stress). The opener reacts warmly to the category and asks for goals in one merged moment, then the Goals tiles appear. Collect one or two goals. Map what the user says to the exact on-screen label; if they speak generally, map to the closest one or ask one short question. One or two, no more. The goal count sets up the downstream habit distribution. Do not read the tiles out loud, do not coach or explain per goal, do not allow more than two.",
      "allowedTools": [
        "submit_goals",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.goals",
            "writtenBy": "submit_goals"
          }
        ],
        "reads": [
          {
            "key": "onboarding.category"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_goals fired with 1 to 2 valid goals, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "the goal count sets up the habit distribution: two goals -> the next beat gives one habit per goal; one goal -> the next beat allows one or two habits. Each picked goal routes to its matching habits-* opener (e.g. Feel calmer during the day -> habits-calmer-day)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_goals errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked tiles stay selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_goals_stress_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the goal question (\"Which of these feels right to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_goals_stress_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not choose: falls to the plain one-line re-ask and the tap path (max-turns behavior, no brainstorm; copy-decisions 2026-07-10), never force a pick",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no tiles appeared for the user: ask one neutral question (\"Is anything coming up for you to pick from?\"), do NOT recite the goal list to fill the silence",
            "voice": "clip-family:onboard_goals_stress_edge_4 (pending recording)"
          },
          {
            "edge": "names three",
            "behavior": "ask which two matter most, then take those two",
            "voice": null
          },
          {
            "edge": "vague / general (\"just less stress in general\")",
            "behavior": "map to the closest label or ask one short question to pin it (\"If you had to pick one, what bothers you most?\"); never invent a label",
            "voice": "clip-family:onboard_goals_stress_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_02_stress",
            "clipPath": "/voice/ob/onboard_beginner_02_stress.wav"
          }
        ]
      }
    },
    {
      "id": "goals-focus",
      "order": 18,
      "screenId": "ONBOARD-BEGINNER-02--FOCUS",
      "variantOf": "goals-sleep",
      "path": "beginner",
      "component": {
        "key": "goals-list",
        "props": {
          "category": "Improve focus"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "I'm happy you went with focus. There's a specific kind of good that comes from finishing something without your attention scattering everywhere, and I'd love to help you get more of that. Which of these would you like to start with? Pick one or two.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-02--FOCUS"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_02_focus.wav"
        }
      ],
      "opener": "I'm happy you went with focus. There's a specific kind of good that comes from finishing something without your attention scattering everywhere, and I'd love to help you get more of that. Which of these would you like to start with? Pick one or two.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Goals inside the chosen category (Improve focus). The opener reacts warmly to the category and asks for goals in one merged moment, then the Goals tiles appear. Collect one or two goals. Map what the user says to the exact on-screen label; if they speak generally, map to the closest one or ask one short question. One or two, no more. The goal count sets up the downstream habit distribution. Do not read the tiles out loud, do not coach or explain per goal, do not allow more than two.",
      "allowedTools": [
        "submit_goals",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.goals",
            "writtenBy": "submit_goals"
          }
        ],
        "reads": [
          {
            "key": "onboarding.category"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_goals fired with 1 to 2 valid goals, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "the goal count sets up the habit distribution: two goals -> the next beat gives one habit per goal; one goal -> the next beat allows one or two habits. Each picked goal routes to its matching habits-* opener (e.g. Start work with less friction -> habits-start-work)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_goals errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked tiles stay selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_goals_focus_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the goal question (\"Which of these feels right to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_goals_focus_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not choose: falls to the plain one-line re-ask and the tap path (max-turns behavior, no brainstorm; copy-decisions 2026-07-10), never force a pick",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no tiles appeared for the user: ask one neutral question (\"Is anything coming up for you to pick from?\"), do NOT recite the goal list to fill the silence",
            "voice": "clip-family:onboard_goals_focus_edge_4 (pending recording)"
          },
          {
            "edge": "names three",
            "behavior": "ask which two matter most, then take those two",
            "voice": null
          },
          {
            "edge": "vague / general (\"just better focus in general\")",
            "behavior": "map to the closest label or ask one short question to pin it (\"If you had to pick one, what bothers you most?\"); never invent a label",
            "voice": "clip-family:onboard_goals_focus_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_02_focus",
            "clipPath": "/voice/ob/onboard_beginner_02_focus.wav"
          }
        ]
      }
    },
    {
      "id": "goals-break",
      "order": 19,
      "screenId": "ONBOARD-BEGINNER-02--BREAK",
      "variantOf": "goals-sleep",
      "path": "beginner",
      "component": {
        "key": "goals-list",
        "props": {
          "category": "Break bad habits"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Love that you're taking this on. These are the changes that actually free up something in your life, and I think you'll be surprised how good it feels to loosen the grip. Which of these would you like to start with? Pick one or two.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-02--BREAK"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_02_break.wav"
        }
      ],
      "opener": "Love that you're taking this on. These are the changes that actually free up something in your life, and I think you'll be surprised how good it feels to loosen the grip. Which of these would you like to start with? Pick one or two.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Goals inside the chosen category (Break bad habits). The opener reacts warmly to the category and asks for goals in one merged moment, then the Goals tiles appear. Collect one or two goals. Map what the user says to the exact on-screen label; if they speak generally, map to the closest one or ask one short question. One or two, no more. The goal count sets up the downstream habit distribution. Do not read the tiles out loud, do not coach or explain per goal, do not allow more than two.",
      "allowedTools": [
        "submit_goals",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.goals",
            "writtenBy": "submit_goals"
          }
        ],
        "reads": [
          {
            "key": "onboarding.category"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_goals fired with 1 to 2 valid goals, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "the goal count sets up the habit distribution: two goals -> the next beat gives one habit per goal; one goal -> the next beat allows one or two habits. Each picked goal routes to its matching habits-* opener (e.g. Smoking -> habits-smoking)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_goals errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked tiles stay selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_goals_break_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the goal question (\"Which of these feels right to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_goals_break_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not choose: falls to the plain one-line re-ask and the tap path (max-turns behavior, no brainstorm; copy-decisions 2026-07-10), never force a pick",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no tiles appeared for the user: ask one neutral question (\"Is anything coming up for you to pick from?\"), do NOT recite the goal list to fill the silence",
            "voice": "clip-family:onboard_goals_break_edge_4 (pending recording)"
          },
          {
            "edge": "names three",
            "behavior": "ask which two matter most, then take those two",
            "voice": null
          },
          {
            "edge": "vague / general (\"just breaking habits in general\")",
            "behavior": "map to the closest label or ask one short question to pin it (\"If you had to pick one, what bothers you most?\"); never invent a label",
            "voice": "clip-family:onboard_goals_break_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_02_break",
            "clipPath": "/voice/ob/onboard_beginner_02_break.wav"
          }
        ]
      }
    },
    {
      "id": "goals-organize",
      "order": 20,
      "screenId": "ONBOARD-BEGINNER-02--ORGANIZE",
      "variantOf": "goals-sleep",
      "path": "beginner",
      "component": {
        "key": "goals-list",
        "props": {
          "category": "Get more organized"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "I'm happy you picked this. There's something really good about clearing the mental clutter, and I think you're going to feel lighter as we go. Which of these would you like to start with? Pick one or two.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-02--ORGANIZE"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_02_organize.wav"
        }
      ],
      "opener": "I'm happy you picked this. There's something really good about clearing the mental clutter, and I think you're going to feel lighter as we go. Which of these would you like to start with? Pick one or two.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Goals inside the chosen category (Get more organized). The opener reacts warmly to the category and asks for goals in one merged moment, then the Goals tiles appear. Collect one or two goals. Map what the user says to the exact on-screen label; if they speak generally, map to the closest one or ask one short question. One or two, no more. The goal count sets up the downstream habit distribution. Do not read the tiles out loud, do not coach or explain per goal, do not allow more than two.",
      "allowedTools": [
        "submit_goals",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.goals",
            "writtenBy": "submit_goals"
          }
        ],
        "reads": [
          {
            "key": "onboarding.category"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_goals fired with 1 to 2 valid goals, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "the goal count sets up the habit distribution: two goals -> the next beat gives one habit per goal; one goal -> the next beat allows one or two habits. Each picked goal routes to its matching habits-* opener (e.g. Stay on top of tasks -> habits-stay-on-tasks)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_goals errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked tiles stay selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_goals_organize_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the goal question (\"Which of these feels right to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_goals_organize_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not choose: falls to the plain one-line re-ask and the tap path (max-turns behavior, no brainstorm; copy-decisions 2026-07-10), never force a pick",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no tiles appeared for the user: ask one neutral question (\"Is anything coming up for you to pick from?\"), do NOT recite the goal list to fill the silence",
            "voice": "clip-family:onboard_goals_organize_edge_4 (pending recording)"
          },
          {
            "edge": "names three",
            "behavior": "ask which two matter most, then take those two",
            "voice": null
          },
          {
            "edge": "vague / general (\"just being more organized in general\")",
            "behavior": "map to the closest label or ask one short question to pin it (\"If you had to pick one, what bothers you most?\"); never invent a label",
            "voice": "clip-family:onboard_goals_organize_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_02_organize",
            "clipPath": "/voice/ob/onboard_beginner_02_organize.wav"
          }
        ]
      }
    },
    {
      "id": "goal-custom",
      "order": 21,
      "screenId": "ONBOARD-BEGINNER-02-CUSTOM",
      "variantOf": null,
      "path": "beginner",
      "component": {
        "key": "custom-entry",
        "props": {
          "kind": "goal"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "What goal do you want to work toward?",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-02-CUSTOM"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_02_custom_1.wav"
        }
      ],
      "opener": "What goal do you want to work toward?",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Create your own goal. Reached from the create-your-own category tile. Speak the prompt, then let the user name their own goal in the text input, in their own words. Capture it verbatim, add no praise, and move on to the habits.",
      "allowedTools": [
        "submit_goals",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.goals",
            "writtenBy": "submit_goals"
          }
        ],
        "reads": [
          {
            "key": "onboarding.category"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the user submits a non-empty custom goal"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to the habits picker for the custom goal"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "empty submission",
            "behavior": "do not advance on an empty entry; wait for the user to name a goal",
            "voice": null
          },
          {
            "edge": "save contract migration",
            "behavior": "submit_goals must preserve custom-goal wording and write the complete goals array before this beat advances; until migrated, do not substitute a canonical category or invent a goal",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_02_custom_1",
            "clipPath": "/voice/ob/onboard_beginner_02_custom_1.wav"
          }
        ]
      }
    },
    {
      "id": "habits",
      "order": 22,
      "screenId": "ONBOARD-BEGINNER-03",
      "variantOf": null,
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Pick one or two habits that feel doable. One habit that you actually keep is much better than a list of five that you don't keep. Create your own if nothing here fits.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_1.wav"
        },
        {
          "seq": 2,
          "speaker": "coach",
          "words": "Create your own if nothing here fits.",
          "bindsTo": {
            "kind": "component",
            "element": "createOwn",
            "screen": "ONBOARD-BEGINNER-03"
          },
          "voice": "mp3",
          "clipPath": null
        }
      ],
      "opener": "Pick one or two habits that feel doable. One habit that you actually keep is much better than a list of five that you don't keep. Create your own if nothing here fits.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (h-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_1",
            "clipPath": "/voice/ob/onboard_beginner_03_1.wav"
          }
        ]
      }
    },
    {
      "id": "habits-fall-asleep-earlier",
      "order": 23,
      "screenId": "ONBOARD-BEGINNER-03--FALL-ASLEEP-EARLIER",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Fall asleep earlier"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To fall asleep earlier, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--FALL-ASLEEP-EARLIER"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_fall_asleep_earlier.wav"
        }
      ],
      "opener": "To fall asleep earlier, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_fall_asleep_earlier_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_fall_asleep_earlier_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hfallasleepearlier-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_fall_asleep_earlier_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_fall_asleep_earlier_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_fall_asleep_earlier",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_fall_asleep_earlier.wav"
          }
        ]
      }
    },
    {
      "id": "habits-wake-earlier",
      "order": 24,
      "screenId": "ONBOARD-BEGINNER-03--WAKE-EARLIER",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Wake up earlier"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To wake up earlier, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--WAKE-EARLIER"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_wake_earlier.wav"
        }
      ],
      "opener": "To wake up earlier, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_wake_earlier_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_wake_earlier_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hwakeearlier-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_wake_earlier_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_wake_earlier_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_wake_earlier",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_wake_earlier.wav"
          }
        ]
      }
    },
    {
      "id": "habits-sleep-consistently",
      "order": 25,
      "screenId": "ONBOARD-BEGINNER-03--SLEEP-CONSISTENTLY",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Sleep more consistently"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To sleep more consistently, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--SLEEP-CONSISTENTLY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_sleep_consistently.wav"
        }
      ],
      "opener": "To sleep more consistently, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_sleep_consistently_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_sleep_consistently_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hsleepconsistently-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_sleep_consistently_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_sleep_consistently_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_sleep_consistently",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_sleep_consistently.wav"
          }
        ]
      }
    },
    {
      "id": "habits-sleep-deeply",
      "order": 26,
      "screenId": "ONBOARD-BEGINNER-03--SLEEP-DEEPLY",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Sleep more deeply"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To sleep more deeply, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--SLEEP-DEEPLY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_sleep_deeply.wav"
        }
      ],
      "opener": "To sleep more deeply, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_sleep_deeply_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_sleep_deeply_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hsleepdeeply-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_sleep_deeply_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_sleep_deeply_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_sleep_deeply",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_sleep_deeply.wav"
          }
        ]
      }
    },
    {
      "id": "habits-walk-more",
      "order": 27,
      "screenId": "ONBOARD-BEGINNER-03--WALK-MORE",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Walk more"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "For walking more, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--WALK-MORE"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_walk_more.wav"
        }
      ],
      "opener": "For walking more, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_walk_more_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_walk_more_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hwalkmore-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_walk_more_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_walk_more_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_walk_more",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_walk_more.wav"
          }
        ]
      }
    },
    {
      "id": "habits-exercise-consistently",
      "order": 28,
      "screenId": "ONBOARD-BEGINNER-03--EXERCISE-CONSISTENTLY",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Exercise consistently"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To exercise more consistently, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--EXERCISE-CONSISTENTLY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_exercise_consistently.wav"
        }
      ],
      "opener": "To exercise more consistently, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_exercise_consistently_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_exercise_consistently_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hexerciseconsistently-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_exercise_consistently_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_exercise_consistently_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_exercise_consistently",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_exercise_consistently.wav"
          }
        ]
      }
    },
    {
      "id": "habits-mobility",
      "order": 29,
      "screenId": "ONBOARD-BEGINNER-03--MOBILITY",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Improve mobility"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "For better mobility, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--MOBILITY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_mobility.wav"
        }
      ],
      "opener": "For better mobility, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_mobility_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_mobility_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hmobility-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_mobility_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_mobility_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_mobility",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_mobility.wav"
          }
        ]
      }
    },
    {
      "id": "habits-eat-intentionally",
      "order": 30,
      "screenId": "ONBOARD-BEGINNER-03--EAT-INTENTIONALLY",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Eat more intentionally"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To eat more intentionally, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--EAT-INTENTIONALLY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_eat_intentionally.wav"
        }
      ],
      "opener": "To eat more intentionally, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_eat_intentionally_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_eat_intentionally_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (heatintentionally-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_eat_intentionally_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_eat_intentionally_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_eat_intentionally",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_eat_intentionally.wav"
          }
        ]
      }
    },
    {
      "id": "habits-reduce-overeating",
      "order": 31,
      "screenId": "ONBOARD-BEGINNER-03--REDUCE-OVEREATING",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Reduce overeating"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To reduce overeating, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--REDUCE-OVEREATING"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_reduce_overeating.wav"
        }
      ],
      "opener": "To reduce overeating, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_reduce_overeating_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_reduce_overeating_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hreduceovereating-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_reduce_overeating_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_reduce_overeating_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_reduce_overeating",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_reduce_overeating.wav"
          }
        ]
      }
    },
    {
      "id": "habits-plan-food",
      "order": 32,
      "screenId": "ONBOARD-BEGINNER-03--PLAN-FOOD",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Plan food better"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To plan your food better, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--PLAN-FOOD"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_plan_food.wav"
        }
      ],
      "opener": "To plan your food better, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_plan_food_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_plan_food_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hplanfood-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_plan_food_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_plan_food_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_plan_food",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_plan_food.wav"
          }
        ]
      }
    },
    {
      "id": "habits-morning-energy",
      "order": 33,
      "screenId": "ONBOARD-BEGINNER-03--MORNING-ENERGY",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Have more morning energy"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "For more morning energy, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--MORNING-ENERGY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_morning_energy.wav"
        }
      ],
      "opener": "For more morning energy, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_morning_energy_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_morning_energy_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hmorningenergy-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_morning_energy_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_morning_energy_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_morning_energy",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_morning_energy.wav"
          }
        ]
      }
    },
    {
      "id": "habits-avoid-crashes",
      "order": 34,
      "screenId": "ONBOARD-BEGINNER-03--AVOID-CRASHES",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Avoid afternoon crashes"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To avoid afternoon crashes, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--AVOID-CRASHES"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_avoid_crashes.wav"
        }
      ],
      "opener": "To avoid afternoon crashes, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_avoid_crashes_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_avoid_crashes_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (havoidcrashes-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_avoid_crashes_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_avoid_crashes_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_avoid_crashes",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_avoid_crashes.wav"
          }
        ]
      }
    },
    {
      "id": "habits-stable-energy",
      "order": 35,
      "screenId": "ONBOARD-BEGINNER-03--STABLE-ENERGY",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Keep energy more stable"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To keep your energy more stable, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--STABLE-ENERGY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_stable_energy.wav"
        }
      ],
      "opener": "To keep your energy more stable, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_stable_energy_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_stable_energy_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hstableenergy-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_stable_energy_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_stable_energy_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_stable_energy",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_stable_energy.wav"
          }
        ]
      }
    },
    {
      "id": "habits-calmer-day",
      "order": 36,
      "screenId": "ONBOARD-BEGINNER-03--CALMER-DAY",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Feel calmer during the day"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To feel calmer during the day, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--CALMER-DAY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_calmer_day.wav"
        }
      ],
      "opener": "To feel calmer during the day, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_calmer_day_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_calmer_day_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hcalmerday-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_calmer_day_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_calmer_day_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_calmer_day",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_calmer_day.wav"
          }
        ]
      }
    },
    {
      "id": "habits-evening-stress",
      "order": 37,
      "screenId": "ONBOARD-BEGINNER-03--EVENING-STRESS",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Reduce evening stress"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To reduce evening stress, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--EVENING-STRESS"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_evening_stress.wav"
        }
      ],
      "opener": "To reduce evening stress, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_evening_stress_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_evening_stress_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (heveningstress-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_evening_stress_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_evening_stress_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_evening_stress",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_evening_stress.wav"
          }
        ]
      }
    },
    {
      "id": "habits-less-overwhelmed",
      "order": 38,
      "screenId": "ONBOARD-BEGINNER-03--LESS-OVERWHELMED",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Feel less overwhelmed"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To feel less overwhelmed, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--LESS-OVERWHELMED"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_less_overwhelmed.wav"
        }
      ],
      "opener": "To feel less overwhelmed, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_less_overwhelmed_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_less_overwhelmed_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hlessoverwhelmed-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_less_overwhelmed_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_less_overwhelmed_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_less_overwhelmed",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_less_overwhelmed.wav"
          }
        ]
      }
    },
    {
      "id": "habits-start-work",
      "order": 39,
      "screenId": "ONBOARD-BEGINNER-03--START-WORK",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Start work with less friction"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To start work with less friction, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--START-WORK"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_start_work.wav"
        }
      ],
      "opener": "To start work with less friction, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_start_work_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_start_work_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hstartwork-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_start_work_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_start_work_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_start_work",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_start_work.wav"
          }
        ]
      }
    },
    {
      "id": "habits-deeper-work",
      "order": 40,
      "screenId": "ONBOARD-BEGINNER-03--DEEPER-WORK",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Do deeper work"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "For deeper work, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--DEEPER-WORK"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_deeper_work.wav"
        }
      ],
      "opener": "For deeper work, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_deeper_work_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_deeper_work_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hdeeperwork-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_deeper_work_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_deeper_work_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_deeper_work",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_deeper_work.wav"
          }
        ]
      }
    },
    {
      "id": "habits-procrastinate-less",
      "order": 41,
      "screenId": "ONBOARD-BEGINNER-03--PROCRASTINATE-LESS",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Procrastinate less"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To procrastinate less, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--PROCRASTINATE-LESS"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_procrastinate_less.wav"
        }
      ],
      "opener": "To procrastinate less, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_procrastinate_less_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_procrastinate_less_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hprocrastinateless-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_procrastinate_less_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_procrastinate_less_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_procrastinate_less",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_procrastinate_less.wav"
          }
        ]
      }
    },
    {
      "id": "habits-smoking",
      "order": 42,
      "screenId": "ONBOARD-BEGINNER-03--SMOKING",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Smoking"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To cut back on smoking, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--SMOKING"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_smoking.wav"
        }
      ],
      "opener": "To cut back on smoking, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_smoking_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_smoking_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hsmoking-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_smoking_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_smoking_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_smoking",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_smoking.wav"
          }
        ]
      }
    },
    {
      "id": "habits-weed",
      "order": 43,
      "screenId": "ONBOARD-BEGINNER-03--WEED",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Weed"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To cut back on weed, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--WEED"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_weed.wav"
        }
      ],
      "opener": "To cut back on weed, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_weed_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_weed_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hweed-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_weed_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_weed_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_weed",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_weed.wav"
          }
        ]
      }
    },
    {
      "id": "habits-alcohol",
      "order": 44,
      "screenId": "ONBOARD-BEGINNER-03--ALCOHOL",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Alcohol"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To cut back on alcohol, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--ALCOHOL"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_alcohol.wav"
        }
      ],
      "opener": "To cut back on alcohol, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_alcohol_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_alcohol_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (halcohol-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_alcohol_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_alcohol_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_alcohol",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_alcohol.wav"
          }
        ]
      }
    },
    {
      "id": "habits-porn",
      "order": 45,
      "screenId": "ONBOARD-BEGINNER-03--PORN",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Porn"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To cut back on porn, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--PORN"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_porn.wav"
        }
      ],
      "opener": "To cut back on porn, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_porn_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_porn_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hporn-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_porn_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_porn_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_porn",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_porn.wav"
          }
        ]
      }
    },
    {
      "id": "habits-phone-use",
      "order": 46,
      "screenId": "ONBOARD-BEGINNER-03--PHONE-USE",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Phone use"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To cut back on phone use, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--PHONE-USE"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_phone_use.wav"
        }
      ],
      "opener": "To cut back on phone use, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_phone_use_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_phone_use_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hphoneuse-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_phone_use_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_phone_use_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_phone_use",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_phone_use.wav"
          }
        ]
      }
    },
    {
      "id": "habits-late-snacking",
      "order": 47,
      "screenId": "ONBOARD-BEGINNER-03--LATE-SNACKING",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Late-night snacking"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To cut back on late-night snacking, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--LATE-SNACKING"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_late_snacking.wav"
        }
      ],
      "opener": "To cut back on late-night snacking, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_late_snacking_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_late_snacking_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hlatesnacking-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_late_snacking_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_late_snacking_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_late_snacking",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_late_snacking.wav"
          }
        ]
      }
    },
    {
      "id": "habits-caffeine",
      "order": 48,
      "screenId": "ONBOARD-BEGINNER-03--CAFFEINE",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Caffeine"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To cut back on caffeine, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--CAFFEINE"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_caffeine.wav"
        }
      ],
      "opener": "To cut back on caffeine, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_caffeine_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_caffeine_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hcaffeine-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_caffeine_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_caffeine_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_caffeine",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_caffeine.wav"
          }
        ]
      }
    },
    {
      "id": "habits-stay-on-tasks",
      "order": 49,
      "screenId": "ONBOARD-BEGINNER-03--STAY-ON-TASKS",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Stay on top of tasks"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To stay on top of your tasks, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--STAY-ON-TASKS"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_stay_on_tasks.wav"
        }
      ],
      "opener": "To stay on top of your tasks, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_stay_on_tasks_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_stay_on_tasks_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hstayontasks-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_stay_on_tasks_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_stay_on_tasks_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_stay_on_tasks",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_stay_on_tasks.wav"
          }
        ]
      }
    },
    {
      "id": "habits-tidy-spaces",
      "order": 50,
      "screenId": "ONBOARD-BEGINNER-03--TIDY-SPACES",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Keep spaces tidy"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To keep your spaces tidy, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--TIDY-SPACES"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_tidy_spaces.wav"
        }
      ],
      "opener": "To keep your spaces tidy, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_tidy_spaces_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_tidy_spaces_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (htidyspaces-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_tidy_spaces_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_tidy_spaces_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_tidy_spaces",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_tidy_spaces.wav"
          }
        ]
      }
    },
    {
      "id": "habits-life-admin",
      "order": 51,
      "screenId": "ONBOARD-BEGINNER-03--LIFE-ADMIN",
      "variantOf": "habits",
      "path": "beginner",
      "component": {
        "key": "habit-picker",
        "props": {
          "goal": "Handle life admin better"
        },
        "config": {
          "hideOrb": false
        },
        "elements": [
          "createOwn"
        ]
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "To handle life admin better, let's pick a habit or two you'll actually keep.",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03--LIFE-ADMIN"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_goal_life_admin.wav"
        }
      ],
      "opener": "To handle life admin better, let's pick a habit or two you'll actually keep.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit selection after the goal(s) are chosen. The opener reacts to the picked goal and asks for a habit or two that feels doable, then the habit options appear. If two goals were picked, collect one habit per goal (two total, one each); if one goal was picked, collect one or two habits for it. Map what the user says to the closest canonical habit name; accept a custom habit only when they offer something not on the list. At least one to continue, at most two total. Do not read the habit list out loud, do not read sub-lists, do not add commentary after each pick. Less is more: one kept habit beats five.",
      "allowedTools": [
        "add_habit",
        "remove_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "add_habit fired with at least one habit within the cap, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "once the habit(s) are captured within the cap, onboarding continues to the next step (schedule / day-picker), then the reflection beats"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "add_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" and the picked habit stays selected for the retry. Voice path: one short coach line \"That didn't go through, let me try again.\" (Yair-approved tool-failure contract, 2026-07-09.)",
            "voice": "clip-family:onboard_beginner_03_goal_life_admin_edge_1 (pending recording)"
          },
          {
            "edge": "off-topic input",
            "behavior": "one short acknowledgement, at most one sentence, no new topic and no advice, then re-ask the habit question (\"Which of these feels doable to start with?\"). Do not follow the tangent, do not add commentary, do not advance.",
            "voice": "clip-family:onboard_beginner_03_goal_life_admin_edge_2 (pending recording)"
          },
          {
            "edge": "skip / decline",
            "behavior": "user will not pick: at least one habit is needed to continue; help them find one small doable habit (hlifeadmin-keep-the-gem), never force a heroic one",
            "voice": null
          },
          {
            "edge": "empty state",
            "behavior": "no habit options appeared for the user: ask one neutral question (\"Is there one small thing you could keep?\"), do NOT recite the habit list to fill the silence",
            "voice": "clip-family:onboard_beginner_03_goal_life_admin_edge_4 (pending recording)"
          },
          {
            "edge": "over the cap",
            "behavior": "user wants three or more habits: keep it to one or two, ask which matter most, then take those",
            "voice": null
          },
          {
            "edge": "not on the list / custom",
            "behavior": "user offers something not on the list: accept it as a custom habit (\"Create your own\"); never force it onto a canonical name and never invent one",
            "voice": "clip-family:onboard_beginner_03_goal_life_admin_edge_6 (pending recording)"
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_goal_life_admin",
            "clipPath": "/voice/ob/onboard_beginner_03_goal_life_admin.wav"
          }
        ]
      }
    },
    {
      "id": "habit-custom",
      "order": 52,
      "screenId": "ONBOARD-BEGINNER-03-CUSTOM",
      "variantOf": null,
      "path": "beginner",
      "component": {
        "key": "custom-entry",
        "props": {
          "kind": "habit"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "What habit do you want to build?",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-BEGINNER-03-CUSTOM"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_03_custom_1.wav"
        }
      ],
      "opener": "What habit do you want to build?",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Create your own habit. Reached from the create-your-own habit tile. Speak the prompt, then let the user name their own habit in the text input, in their own words. Capture it verbatim, add no praise, and move on to setting the days.",
      "allowedTools": [
        "add_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "add_habit / remove_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.goals"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the user submits a non-empty custom habit"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to the habit schedule (set the days)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "empty submission",
            "behavior": "do not advance on an empty entry; wait for the user to name a habit",
            "voice": null
          },
          {
            "edge": "cap reached",
            "behavior": "the 2-habit cap (decision 4/5) is enforced at the add_habit handler; the render surfaces the cap",
            "voice": null
          },
          {
            "edge": "save contract",
            "behavior": "add_habit saves the custom name with defaults, enforces the total cap, and must succeed before this beat advances",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_03_custom_1",
            "clipPath": "/voice/ob/onboard_beginner_03_custom_1.wav"
          }
        ]
      }
    },
    {
      "id": "schedule",
      "order": 53,
      "screenId": "ONBOARD-BEGINNER-04",
      "variantOf": null,
      "path": "beginner",
      "component": {
        "key": "habit-schedule",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Please set the days that you're going to actually do these habits.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-1",
            "screen": "ONBOARD-BEGINNER-04"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_04_1.wav"
        },
        {
          "seq": 2,
          "speaker": "coach",
          "words": "Not every habit needs to be done every day. Three specific days in the week is great as well. Once a week for specific habits, also great.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-2",
            "screen": "ONBOARD-BEGINNER-04"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_beginner_04_2.wav"
        },
        {
          "seq": 3,
          "speaker": "coach",
          "words": "",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-99",
            "screen": "ONBOARD-BEGINNER-04"
          },
          "voice": "mp3",
          "clipPath": null
        }
      ],
      "opener": "Please set the days that you're going to actually do these habits.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit schedule. Shows all the habits the user just picked, each as its own card with the habit name and its day picker. The morning check-in and evening reflection are NOT here (rituals, not habits). For each habit, set which days; recommend weekdays to start. Days default to the weekday preset by locale. Per-habit reminders are OFF by default, on only if the user asks. Never turn a reminder on unless they ask, never re-ask a piece already given, and never include the check-in or reflection as habits.",
      "allowedTools": [
        "add_habit",
        "update_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "update_habit / add_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.habits"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "every picked habit has its days set (via update_habit), then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to the plan confirm"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "update_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" with the days retained. Voice path: one short coach line \"That didn't go through, let me try again.\"",
            "voice": "clip-family:onboard_beginner_04_edge_1 (pending recording)"
          },
          {
            "edge": "a habit left with no days",
            "behavior": "prompt once for that habit days; do not advance until every habit has days",
            "voice": null
          },
          {
            "edge": "asks for a reminder",
            "behavior": "turn the per-habit reminder on for that habit; otherwise reminders stay OFF",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_beginner_04_1",
            "clipPath": "/voice/ob/onboard_beginner_04_1.wav"
          },
          {
            "clip": "onboard_beginner_04_2",
            "clipPath": "/voice/ob/onboard_beginner_04_2.wav"
          }
        ]
      }
    },
    {
      "id": "advanced-capture",
      "order": 54,
      "screenId": "ONBOARD-ADVANCED",
      "variantOf": null,
      "path": "advanced",
      "component": {
        "key": "advanced-capture",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Read me the habits you already track. We'll pick days next. For now just the list, and I recommend starting small, you can always add more.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-1",
            "screen": "ONBOARD-ADVANCED"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_advanced_1.wav"
        },
        {
          "seq": 2,
          "speaker": "coach",
          "words": "",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-99",
            "screen": "ONBOARD-ADVANCED"
          },
          "voice": "mp3",
          "clipPath": null
        },
        {
          "seq": 3,
          "speaker": "coach",
          "words": "Those are all in, and I marked each as build or break. Tell me if any look wrong. If they're good, we'll set the days next.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-3",
            "screen": "ONBOARD-ADVANCED"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/close.wav"
        }
      ],
      "opener": "Read me the habits you already track. We'll pick days next. For now just the list, and I recommend starting small, you can always add more.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Advanced capture. The user already has habits. Let them read or type them all, in their own words. Each one forms on screen as a card, auto-marked build or break (avoidance wording reads as break, everything else as build). Do NOT ask build or break per habit. Capture verbatim, do not reorganize as they talk. Less is more, especially at the start, they can build on it later. When they finish, name the build and break read once over the whole set and ask for a single yes. If they flag one as wrong, fix that one. Then the days get set on the next beat.",
      "allowedTools": [
        "submit_brain_dump",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "advanced.brainDump",
            "writtenBy": "submit_brain_dump"
          }
        ],
        "reads": [
          {
            "key": "flow.path"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "submit_brain_dump captured the confirmed set, then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to advanced-frequency (order 55) to set the days"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "submit_brain_dump errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" with the cards retained. Voice path: one short coach line \"That didn't go through, let me try again.\"",
            "voice": "clip-family:onboard_advanced_edge_1 (pending recording)"
          },
          {
            "edge": "flags a card wrong",
            "behavior": "fix that one card only; never reorganize or reword the rest",
            "voice": null
          },
          {
            "edge": "user reports something heavy",
            "behavior": "if the user shares something hard, drop the capture, be human first, and do not rush them back (global glob-crisis)",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_advanced_1",
            "clipPath": "/voice/ob/onboard_advanced_1.wav"
          },
          {
            "clip": "close",
            "clipPath": "/voice/ob/close.wav"
          }
        ]
      }
    },
    {
      "id": "advanced-frequency",
      "order": 55,
      "screenId": "ONBOARD-ADVANCED-FREQUENCY",
      "variantOf": null,
      "path": "advanced",
      "component": {
        "key": "advanced-frequency",
        "props": null,
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Please set the days that you're going to actually do these habits.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-1",
            "screen": "ONBOARD-ADVANCED-FREQUENCY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_advanced_frequency_days.wav"
        },
        {
          "seq": 2,
          "speaker": "coach",
          "words": "Not every habit needs to be done every day. Three specific days in the week is great as well. Once a week for a certain habit, also great.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-2",
            "screen": "ONBOARD-ADVANCED-FREQUENCY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_advanced_frequency_1.wav"
        },
        {
          "seq": 3,
          "speaker": "coach",
          "words": "",
          "bindsTo": {
            "kind": "component",
            "element": "reveal-99",
            "screen": "ONBOARD-ADVANCED-FREQUENCY"
          },
          "voice": "mp3",
          "clipPath": null
        },
        {
          "seq": 4,
          "speaker": "coach",
          "words": "Your habits are all set, your plan is ready.",
          "bindsTo": {
            "kind": "bubble",
            "element": "bubble-4",
            "screen": "ONBOARD-ADVANCED-FREQUENCY"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_advanced_frequency_2.wav"
        }
      ],
      "opener": "Please set the days that you're going to actually do these habits.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Habit days, advanced. The habits are already captured as cards. Now set how often each one runs; the day circles grow out of the same cards. Parse a full answer when the user gives one, ask only for what is missing. Per-habit reminders OFF by default. Go through them, then the plan is ready. Never re-ask anything already captured, and never turn a reminder on unless they ask.",
      "allowedTools": [
        "add_habit",
        "update_habit",
        "advance_step"
      ],
      "persistence": {
        "writes": [
          {
            "key": "onboarding.habits",
            "writtenBy": "update_habit / remove_habit / add_habit"
          }
        ],
        "reads": [
          {
            "key": "onboarding.habits"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "every captured habit has its days set (via update_habit), then advance_step"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to the plan confirm (the plan is ready)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "update_habit errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not advance. Tap/text path: a toast \"Couldn't save that, tap to retry\" with the days retained. Voice path: one short coach line \"That didn't go through, let me try again.\"",
            "voice": "clip-family:onboard_advanced_frequency_edge_1 (pending recording)"
          },
          {
            "edge": "partial frequency answer",
            "behavior": "take what was given, ask only for the missing habits days; never re-ask a set one",
            "voice": null
          },
          {
            "edge": "asks for a reminder",
            "behavior": "turn the per-habit reminder on for that habit; otherwise reminders stay OFF",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_advanced_frequency_days",
            "clipPath": "/voice/ob/onboard_advanced_frequency_days.wav"
          },
          {
            "clip": "onboard_advanced_frequency_1",
            "clipPath": "/voice/ob/onboard_advanced_frequency_1.wav"
          },
          {
            "clip": "onboard_advanced_frequency_2",
            "clipPath": "/voice/ob/onboard_advanced_frequency_2.wav"
          }
        ]
      }
    },
    {
      "id": "plan",
      "order": 56,
      "screenId": "ONBOARD-COMPLETE",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "into-app",
        "props": {
          "buttonLabel": "Ready to start"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Here's your plan. Your check-in, your reflection, and the habits you picked. Ready to start?",
          "bindsTo": {
            "kind": "bubble",
            "element": "opener",
            "screen": "ONBOARD-COMPLETE"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_complete_1.wav"
        }
      ],
      "opener": "Here's your plan. Your check-in, your reflection, and the habits you picked. Ready to start?",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Full plan. One confirm. Show the whole plan: morning check-in, evening habit report, and evening reflection on the user locale-driven work week, with weekends off by default, plus all the habits under them. Israel runs Sunday through Thursday; everywhere else runs Monday through Friday. It is read-only. Ask whether they are ready to start. On approval, they enter the app. This is a high-investment moment, so make the line real and specific, not generic. On the tap path, show one \"Ready to start\" button; on voice, no button, the user just speaks approval.",
      "allowedTools": [
        "confirm_plan"
      ],
      "persistence": {
        "writes": [
          {
            "key": "plan.confirmed",
            "writtenBy": "confirm_plan"
          }
        ],
        "reads": [
          {
            "key": "checkin.config"
          },
          {
            "key": "reflection.config"
          },
          {
            "key": "onboarding.habits"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the user approves and confirm_plan completes onboarding into the app"
        },
        "branches": {
          "kind": "prose",
          "text": "on approval, into the app, then the weekly projection frames"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "tool failure",
            "behavior": "confirm_plan errors: retry once quietly. If it still fails, SURFACE it, never fail silently, and do not enter the app. Tap/text path: a toast \"Couldn't save that, tap to retry\". Voice path: one short coach line \"That didn't go through, let me try again.\"",
            "voice": "clip-family:onboard_complete_edge_1 (pending recording)"
          },
          {
            "edge": "no tap on voice path",
            "behavior": "no button on voice; take spoken approval and instrument users who complete without a tap",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_complete_1",
            "clipPath": "/voice/ob/onboard_complete_1.wav"
          }
        ]
      }
    },
    {
      "id": "weekly-blank",
      "order": 57,
      "screenId": "ONBOARD-WEEKLY-PROJECTION-BLANK",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "weekly-projection",
        "props": {
          "state": "blank"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "This is your week. Blank, starting today.",
          "bindsTo": {
            "kind": "component",
            "element": "opener-line",
            "screen": "ONBOARD-WEEKLY-PROJECTION-BLANK"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_weekly_projection_blank_1.wav"
        }
      ],
      "opener": "This is your week. Blank, starting today.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Weekly projection, frame 1 of 5. The week grid animates in blank, starting today. One verbatim line, timed to the frame. The five frames together carry the message: reporting itself is the win, weekly reassessment is the loop, a miss still counts, the one thing to avoid is the unreported gap.",
      "allowedTools": [],
      "persistence": {
        "writes": [],
        "reads": [
          {
            "key": "onboarding.habits"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the user taps Next after the line lands"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to weekly-full (order 58)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "audio fails to play",
            "behavior": "show the line as text and keep the Next affordance; never strand a silent frame",
            "voice": null
          },
          {
            "edge": "grid animation not ready",
            "behavior": "if the projection grid cannot mount, show the narrated frame text, a visible “Projection unavailable” status, and the Next affordance; do not fabricate rows or claim a projection rendered",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_weekly_projection_blank_1",
            "clipPath": "/voice/ob/onboard_weekly_projection_blank_1.wav"
          }
        ]
      }
    },
    {
      "id": "weekly-full",
      "order": 58,
      "screenId": "ONBOARD-WEEKLY-PROJECTION-FULL",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "weekly-projection",
        "props": {
          "state": "full"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Best case, every day green. 100% success. That would be amazing.",
          "bindsTo": {
            "kind": "component",
            "element": "opener-line",
            "screen": "ONBOARD-WEEKLY-PROJECTION-FULL"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_weekly_projection_full_1.wav"
        }
      ],
      "opener": "Best case, every day green. 100% success. That would be amazing.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Weekly projection, frame 2 of 5. The week grid fills all-green. One verbatim line, timed to the frame. This is the best-case frame, held lightly; the realistic frames come next.",
      "allowedTools": [],
      "persistence": {
        "writes": [],
        "reads": [
          {
            "key": "onboarding.habits"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the user taps Next after the line lands"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to weekly-p78 (order 59)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "audio fails to play",
            "behavior": "show the line as text and keep the Next affordance; never strand a silent frame",
            "voice": null
          },
          {
            "edge": "grid animation not ready",
            "behavior": "if the projection grid cannot mount, show the narrated frame text, a visible “Projection unavailable” status, and the Next affordance; do not fabricate rows or claim a projection rendered",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_weekly_projection_full_1",
            "clipPath": "/voice/ob/onboard_weekly_projection_full_1.wav"
          }
        ]
      }
    },
    {
      "id": "weekly-p78",
      "order": 59,
      "screenId": "ONBOARD-WEEKLY-PROJECTION-P78",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "weekly-projection",
        "props": {
          "state": "p78"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Most likely your week looks somewhere around here. Mostly green, a few misses. Still a real win.",
          "bindsTo": {
            "kind": "component",
            "element": "opener-line",
            "screen": "ONBOARD-WEEKLY-PROJECTION-P78"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_weekly_projection_p78_1.wav"
        }
      ],
      "opener": "Most likely your week looks somewhere around here. Mostly green, a few misses. Still a real win.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Weekly projection, frame 3 of 5. The grid shows mostly green with a few misses. One verbatim line, timed to the frame. This is the realistic win frame, the one that matters most.",
      "allowedTools": [],
      "persistence": {
        "writes": [],
        "reads": [
          {
            "key": "onboarding.habits"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the user taps Next after the line lands"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to weekly-p36 (order 60)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "audio fails to play",
            "behavior": "show the line as text and keep the Next affordance; never strand a silent frame",
            "voice": null
          },
          {
            "edge": "grid animation not ready",
            "behavior": "if the projection grid cannot mount, show the narrated frame text, a visible “Projection unavailable” status, and the Next affordance; do not fabricate rows or claim a projection rendered",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_weekly_projection_p78_1",
            "clipPath": "/voice/ob/onboard_weekly_projection_p78_1.wav"
          }
        ]
      }
    },
    {
      "id": "weekly-p36",
      "order": 60,
      "screenId": "ONBOARD-WEEKLY-PROJECTION-P36",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "weekly-projection",
        "props": {
          "state": "p36"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "Some weeks can look like this. And even that's okay, because you're in the process and you're consistent inside the process.",
          "bindsTo": {
            "kind": "component",
            "element": "opener-line",
            "screen": "ONBOARD-WEEKLY-PROJECTION-P36"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_weekly_projection_p36_1.wav"
        }
      ],
      "opener": "Some weeks can look like this. And even that's okay, because you're in the process and you're consistent inside the process.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Weekly projection, frame 4 of 5. The grid shows a rough week, one streak surviving. One verbatim line, timed to the frame. The message: a rough week is still building, we reassess, no guilt.",
      "allowedTools": [],
      "persistence": {
        "writes": [],
        "reads": [
          {
            "key": "onboarding.habits"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the user taps Next after the line lands"
        },
        "branches": {
          "kind": "prose",
          "text": "proceeds to weekly-gaps (order 61)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "audio fails to play",
            "behavior": "show the line as text and keep the Next affordance; never strand a silent frame",
            "voice": null
          },
          {
            "edge": "grid animation not ready",
            "behavior": "if the projection grid cannot mount, show the narrated frame text, a visible “Projection unavailable” status, and the Next affordance; do not fabricate rows or claim a projection rendered",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_weekly_projection_p36_1",
            "clipPath": "/voice/ob/onboard_weekly_projection_p36_1.wav"
          }
        ]
      }
    },
    {
      "id": "weekly-gaps",
      "order": 61,
      "screenId": "ONBOARD-WEEKLY-PROJECTION-GAPS",
      "variantOf": null,
      "path": "both",
      "component": {
        "key": "weekly-projection",
        "props": {
          "state": "gaps"
        },
        "config": {
          "hideOrb": false
        },
        "elements": []
      },
      "script": [
        {
          "seq": 1,
          "speaker": "coach",
          "words": "The one thing you want to avoid is this. The empty days you never reported. Stay consistent, just report it. Even a miss counts. That keeps the momentum going.",
          "bindsTo": {
            "kind": "component",
            "element": "opener-line",
            "screen": "ONBOARD-WEEKLY-PROJECTION-GAPS"
          },
          "voice": "mp3",
          "clipPath": "/voice/ob/onboard_weekly_projection_gaps_1.wav"
        }
      ],
      "opener": "The one thing you want to avoid is this. The empty days you never reported. Stay consistent, just report it. Even a miss counts. That keeps the momentum going.",
      "voiceEngine": "MP3",
      "voiceMode": "Verbatim",
      "context": "Weekly projection, frame 5 of 5, the close. The grid shows empty, unreported days. One verbatim line, timed to the frame. The message: the only thing to avoid is the unreported gap, even a miss counts when you report it.",
      "allowedTools": [],
      "persistence": {
        "writes": [],
        "reads": [
          {
            "key": "onboarding.habits"
          }
        ]
      },
      "flow": {
        "advanceWhen": {
          "kind": "prose",
          "text": "the user taps Next after the line lands"
        },
        "branches": {
          "kind": "prose",
          "text": "the onboarding flow completes and the user enters the app (final projection frame)"
        }
      },
      "edges": {
        "kind": "prose",
        "rows": [
          {
            "edge": "audio fails to play",
            "behavior": "show the line as text and keep the Next affordance; never strand a silent frame",
            "voice": null
          },
          {
            "edge": "grid animation not ready",
            "behavior": "if the projection grid cannot mount, show the narrated frame text, a visible “Projection unavailable” status, and the Next affordance; do not fabricate rows or claim a projection rendered",
            "voice": null
          }
        ]
      },
      "assets": {
        "clips": [
          {
            "clip": "onboard_weekly_projection_gaps_1",
            "clipPath": "/voice/ob/onboard_weekly_projection_gaps_1.wav"
          }
        ]
      }
    }
  ],
  "acceptance": [
    {
      "beatId": "splash",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "the brand splash renders on cold start; no interactive tiles or inputs appear"
        },
        {
          "criterion": "stays silent",
          "check": "no coach audio or bubble plays (silent structural beat)"
        },
        {
          "criterion": "advances correctly",
          "check": "the flow proceeds to get-started with no user action required"
        }
      ]
    },
    {
      "beatId": "get-started",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "the get-started frame renders with the single Get started affordance"
        },
        {
          "criterion": "stays silent",
          "check": "no coach audio or bubble plays (silent structural beat)"
        },
        {
          "criterion": "advances correctly",
          "check": "the tap proceeds to coach-greeting; no data is captured"
        }
      ]
    },
    {
      "beatId": "coach-greeting",
      "rows": [
        {
          "criterion": "says the right thing",
          "check": "the recorded greeting plays verbatim from coach_greeting"
        },
        {
          "criterion": "shows the right thing",
          "check": "a single coach bubble renders; no interactive tiles or inputs appear"
        },
        {
          "criterion": "advances correctly",
          "check": "the flow auto-advances to sign-up when the clip ends, with no user action"
        }
      ]
    },
    {
      "beatId": "sign-up",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders the auth-signup screen with Apple / Google / email options, nothing preselected"
        },
        {
          "criterion": "stays silent",
          "check": "no coach audio or bubble plays during auth (silent-beat check)"
        },
        {
          "criterion": "advances correctly",
          "check": "advance fires only after a valid session is established and the name is captured"
        },
        {
          "criterion": "survives a refresh",
          "check": "an authenticated session resumes past sign-up; the beat is not re-shown"
        }
      ]
    },
    {
      "beatId": "mic-permission",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders the mic-permission screen with the Allow / Not now controls"
        },
        {
          "criterion": "says the right thing",
          "check": "the opener plays verbatim from mic_permission_1"
        },
        {
          "criterion": "advances correctly",
          "check": "either Allow or Not now advances the flow; skipping is never penalized"
        }
      ]
    },
    {
      "beatId": "profile-greeting",
      "rows": [
        {
          "criterion": "says the right thing",
          "check": "the greeting plays verbatim with the captured name filled into the {name} slot"
        },
        {
          "criterion": "shows the right thing",
          "check": "a single coach bubble renders; no interactive tiles or inputs appear"
        },
        {
          "criterion": "advances correctly",
          "check": "the flow auto-advances to profile-asks when the clip ends, with no user action"
        }
      ]
    },
    {
      "beatId": "profile-asks",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders the age input and the Male / Female / Other gender selector, nothing preselected"
        },
        {
          "criterion": "says the right thing",
          "check": "both prompts spoken verbatim; gender is never skippable (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "both fields captured via submit_profile with a canonical gender, then advance_step"
        },
        {
          "criterion": "survives a refresh",
          "check": "age + gender persist, the beat is not re-asked, current_step resumes past profile-asks"
        }
      ]
    },
    {
      "beatId": "state-check",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders the four state cards (sleep, mood, energy, stress); no second card set appears"
        },
        {
          "criterion": "says the right thing",
          "check": "the framing opener and the four questions play verbatim, each asked once"
        },
        {
          "criterion": "advances correctly",
          "check": "all four cards filled, then record_checkin and advance_step"
        }
      ]
    },
    {
      "beatId": "checkin",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders the time picker, day picker, and reminder toggle (reminder ON by default)"
        },
        {
          "criterion": "says the right thing",
          "check": "the setup framing and consistency nudge play verbatim"
        },
        {
          "criterion": "advances correctly",
          "check": "a time and days set via submit_morning_checkin, then advance_step"
        }
      ]
    },
    {
      "beatId": "reflection",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders the style selector (suggested / your template / freeform), a time picker, and a reminder toggle"
        },
        {
          "criterion": "says the right thing",
          "check": "the framing, three questions, and time line play verbatim; the styles are not read aloud"
        },
        {
          "criterion": "advances correctly",
          "check": "a style and time captured via submit_reflection_config, then advance_step"
        },
        {
          "criterion": "survives a refresh",
          "check": "the config persists in reflection_settings, the beat is not re-asked"
        }
      ]
    },
    {
      "beatId": "fork",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders the two path cards, single-select, nothing preselected"
        },
        {
          "criterion": "says the right thing",
          "check": "framing spoken verbatim, fork question verbal-only, no read-aloud list, no filler tail"
        },
        {
          "criterion": "advances correctly",
          "check": "the path captured via submit_path_choice, then advance_step; routes beginner or advanced"
        },
        {
          "criterion": "survives a refresh",
          "check": "the path persists, the beat is not re-asked, current_step resumes past fork"
        }
      ]
    },
    {
      "beatId": "category",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders category-grid default variant, 8 tiles + create-your-own, single-select, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, create-your-own verbal-only, no read / praise / contrarian / platitude (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "exactly one category captured via submit_category, then advance_step; two-category attempt resolves to one first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "category persists, beat not re-asked, current_step resumes past category (persistence resume key)"
        },
        {
          "criterion": "variant is correct",
          "check": "Male and Other render this default beat; gender === 'Female' renders category-women (cat-default-variant)"
        }
      ]
    },
    {
      "beatId": "category-women",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders category-grid variant female, 8 tiles + create-your-own, single-select, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, create-your-own verbal-only, no read / praise / contrarian / platitude (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "exactly one category captured via submit_category, then advance_step; two-category attempt resolves to one first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "category persists, beat not re-asked, current_step resumes past category-women (persistence resume key)"
        },
        {
          "criterion": "variant is correct",
          "check": "gender === 'Female' renders this beat; Male and Other render default category (catw-women-variant)"
        }
      ]
    },
    {
      "beatId": "goals-sleep",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders goals-list for Sleep better, 4 tiles + create-your-own, multi-select 1-2, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, category named once, no read / praise / contrarian / platitude (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "one or two goals captured via submit_goals, then advance_step; a three-goal attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "goals + count persist, beat not re-asked, current_step resumes past goals-sleep (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* opener; the goal count sets the downstream habit distribution"
        }
      ]
    },
    {
      "beatId": "goals-move",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders goals-list for Move more, 3 tiles + create-your-own, multi-select 1-2, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, category named once, no read / praise / contrarian / platitude (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "one or two goals captured via submit_goals, then advance_step; a three-goal attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "goals + count persist, beat not re-asked, current_step resumes past goals-move (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* opener; the goal count sets the downstream habit distribution"
        }
      ]
    },
    {
      "beatId": "goals-eat",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders goals-list for Eat better, 3 tiles + create-your-own, multi-select 1-2, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, category named once, no read / praise / contrarian / platitude (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "one or two goals captured via submit_goals, then advance_step; a three-goal attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "goals + count persist, beat not re-asked, current_step resumes past goals-eat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* opener; the goal count sets the downstream habit distribution"
        }
      ]
    },
    {
      "beatId": "goals-energy",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders goals-list for Feel more energized, 3 tiles + create-your-own, multi-select 1-2, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, category named once, no read / praise / contrarian / platitude (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "one or two goals captured via submit_goals, then advance_step; a three-goal attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "goals + count persist, beat not re-asked, current_step resumes past goals-energy (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* opener; the goal count sets the downstream habit distribution"
        }
      ]
    },
    {
      "beatId": "goals-stress",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders goals-list for Reduce stress, 3 tiles + create-your-own, multi-select 1-2, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, category named once, no read / praise / contrarian / platitude (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "one or two goals captured via submit_goals, then advance_step; a three-goal attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "goals + count persist, beat not re-asked, current_step resumes past goals-stress (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* opener; the goal count sets the downstream habit distribution"
        }
      ]
    },
    {
      "beatId": "goals-focus",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders goals-list for Improve focus, 3 tiles + create-your-own, multi-select 1-2, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, category named once, no read / praise / contrarian / platitude (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "one or two goals captured via submit_goals, then advance_step; a three-goal attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "goals + count persist, beat not re-asked, current_step resumes past goals-focus (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* opener; the goal count sets the downstream habit distribution"
        }
      ]
    },
    {
      "beatId": "goals-break",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders goals-list for Break bad habits, 7 tiles + create-your-own, multi-select 1-2, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, category named once, no read / praise / contrarian / platitude (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "one or two goals captured via submit_goals, then advance_step; a three-goal attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "goals + count persist, beat not re-asked, current_step resumes past goals-break (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* opener; the goal count sets the downstream habit distribution"
        }
      ]
    },
    {
      "beatId": "goals-organize",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders goals-list for Get more organized, 3 tiles + create-your-own, multi-select 1-2, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, category named once, no read / praise / contrarian / platitude (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "one or two goals captured via submit_goals, then advance_step; a three-goal attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "goals + count persist, beat not re-asked, current_step resumes past goals-organize (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* opener; the goal count sets the downstream habit distribution"
        }
      ]
    },
    {
      "beatId": "goal-custom",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders a single text input for the custom goal, nothing preselected"
        },
        {
          "criterion": "says the right thing",
          "check": "the prompt plays verbatim from onboard_beginner_02_custom_1"
        },
        {
          "criterion": "advances correctly",
          "check": "a non-empty custom goal is captured, then the flow proceeds to habits"
        }
      ]
    },
    {
      "beatId": "habits",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-fall-asleep-earlier",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-wake-earlier",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-sleep-consistently",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-sleep-deeply",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-walk-more",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-exercise-consistently",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-mobility",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-eat-intentionally",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-reduce-overeating",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-plan-food",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-morning-energy",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-avoid-crashes",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-stable-energy",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-calmer-day",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-evening-stress",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-less-overwhelmed",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-start-work",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-deeper-work",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-procrastinate-less",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-smoking",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-weed",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-alcohol",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-porn",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-phone-use",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-late-snacking",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-caffeine",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-stay-on-tasks",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-tidy-spaces",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habits-life-admin",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit-picker under the opener, habit options for the picked goal(s) + create-your-own, multi-select within the cap, nothing preselected (diff phone vs components)"
        },
        {
          "criterion": "says the right thing",
          "check": "opener spoken verbatim, no read / praise / commentary; one habit per goal with two goals (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "at least one habit captured via add_habit within the cap, then advance_step; a three-habit attempt resolves to two first (flow gate)"
        },
        {
          "criterion": "survives a refresh",
          "check": "habits persist, beat not re-asked, current_step resumes past this beat (persistence resume key)"
        },
        {
          "criterion": "routes correctly",
          "check": "each picked goal routes to its matching habits-* variant; after the pick, onboarding continues to the next step"
        }
      ]
    },
    {
      "beatId": "habit-custom",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders a single text input for the custom habit, nothing preselected"
        },
        {
          "criterion": "says the right thing",
          "check": "the prompt plays verbatim from onboard_beginner_03_custom_1"
        },
        {
          "criterion": "advances correctly",
          "check": "a non-empty custom habit is captured (within the 2-habit cap), then the flow proceeds to the schedule"
        }
      ]
    },
    {
      "beatId": "schedule",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders one card per picked habit with a day picker; no check-in or reflection card appears here"
        },
        {
          "criterion": "says the right thing",
          "check": "the two framing lines play verbatim; weekdays recommended, not forced"
        },
        {
          "criterion": "advances correctly",
          "check": "each habit days set via update_habit, then advance_step"
        }
      ]
    },
    {
      "beatId": "advanced-capture",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders habit cards forming live, each auto-marked build or break; nothing preselected"
        },
        {
          "criterion": "says the right thing",
          "check": "opener and close play verbatim; the coach never asks build or break per habit (rules.context evals)"
        },
        {
          "criterion": "advances correctly",
          "check": "the confirmed set captured via submit_brain_dump, then advance_step"
        }
      ]
    },
    {
      "beatId": "advanced-frequency",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders the captured habit cards, each with a day-circle picker; no new cards are created"
        },
        {
          "criterion": "says the right thing",
          "check": "the framing and plan-ready lines play verbatim; a full answer is parsed, only gaps asked"
        },
        {
          "criterion": "advances correctly",
          "check": "each habit days set via update_habit, then advance_step"
        }
      ]
    },
    {
      "beatId": "plan",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "phone renders the read-only whole plan (all three rituals on the locale-driven work week, plus habits); tap path shows one Ready to start button, voice path shows none"
        },
        {
          "criterion": "says the right thing",
          "check": "the confirm line plays verbatim, real and specific to the plan"
        },
        {
          "criterion": "advances correctly",
          "check": "approval fires the common confirm_plan completion transaction, then enters the app"
        }
      ]
    },
    {
      "beatId": "weekly-blank",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "the blank week grid animates and a Next affordance appears (pending the built component)"
        },
        {
          "criterion": "says the right thing",
          "check": "the frame line plays verbatim from onboard_weekly_projection_blank_1"
        },
        {
          "criterion": "advances correctly",
          "check": "a Next tap proceeds to weekly-full; nothing is captured"
        }
      ]
    },
    {
      "beatId": "weekly-full",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "the week grid fills green and a Next affordance appears (pending the built component)"
        },
        {
          "criterion": "says the right thing",
          "check": "the frame line plays verbatim from onboard_weekly_projection_full_1"
        },
        {
          "criterion": "advances correctly",
          "check": "a Next tap proceeds to weekly-p78; nothing is captured"
        }
      ]
    },
    {
      "beatId": "weekly-p78",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "the grid shows mostly-green with a few misses and a Next affordance appears (pending the built component)"
        },
        {
          "criterion": "says the right thing",
          "check": "the frame line plays verbatim from onboard_weekly_projection_p78_1"
        },
        {
          "criterion": "advances correctly",
          "check": "a Next tap proceeds to weekly-p36; nothing is captured"
        }
      ]
    },
    {
      "beatId": "weekly-p36",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "the grid shows a rough week with one streak surviving and a Next affordance appears (pending the built component)"
        },
        {
          "criterion": "says the right thing",
          "check": "the frame line plays verbatim from onboard_weekly_projection_p36_1"
        },
        {
          "criterion": "advances correctly",
          "check": "a Next tap proceeds to weekly-gaps; nothing is captured"
        }
      ]
    },
    {
      "beatId": "weekly-gaps",
      "rows": [
        {
          "criterion": "shows the right thing",
          "check": "the grid shows empty unreported days and a Next affordance appears (pending the built component)"
        },
        {
          "criterion": "says the right thing",
          "check": "the frame line plays verbatim from onboard_weekly_projection_gaps_1"
        },
        {
          "criterion": "advances correctly",
          "check": "a Next tap closes the projection and enters the app; nothing is captured"
        }
      ]
    }
  ]
} as const;

export const onboardingBeats = onboardingContract.beats;

export const onboardingBeatById = {
  "splash": onboardingContract.beats[0],
  "get-started": onboardingContract.beats[1],
  "coach-greeting": onboardingContract.beats[2],
  "sign-up": onboardingContract.beats[3],
  "mic-permission": onboardingContract.beats[4],
  "profile-greeting": onboardingContract.beats[5],
  "profile-asks": onboardingContract.beats[6],
  "state-check": onboardingContract.beats[7],
  "checkin": onboardingContract.beats[8],
  "reflection": onboardingContract.beats[9],
  "fork": onboardingContract.beats[10],
  "category": onboardingContract.beats[11],
  "category-women": onboardingContract.beats[12],
  "goals-sleep": onboardingContract.beats[13],
  "goals-move": onboardingContract.beats[14],
  "goals-eat": onboardingContract.beats[15],
  "goals-energy": onboardingContract.beats[16],
  "goals-stress": onboardingContract.beats[17],
  "goals-focus": onboardingContract.beats[18],
  "goals-break": onboardingContract.beats[19],
  "goals-organize": onboardingContract.beats[20],
  "goal-custom": onboardingContract.beats[21],
  "habits": onboardingContract.beats[22],
  "habits-fall-asleep-earlier": onboardingContract.beats[23],
  "habits-wake-earlier": onboardingContract.beats[24],
  "habits-sleep-consistently": onboardingContract.beats[25],
  "habits-sleep-deeply": onboardingContract.beats[26],
  "habits-walk-more": onboardingContract.beats[27],
  "habits-exercise-consistently": onboardingContract.beats[28],
  "habits-mobility": onboardingContract.beats[29],
  "habits-eat-intentionally": onboardingContract.beats[30],
  "habits-reduce-overeating": onboardingContract.beats[31],
  "habits-plan-food": onboardingContract.beats[32],
  "habits-morning-energy": onboardingContract.beats[33],
  "habits-avoid-crashes": onboardingContract.beats[34],
  "habits-stable-energy": onboardingContract.beats[35],
  "habits-calmer-day": onboardingContract.beats[36],
  "habits-evening-stress": onboardingContract.beats[37],
  "habits-less-overwhelmed": onboardingContract.beats[38],
  "habits-start-work": onboardingContract.beats[39],
  "habits-deeper-work": onboardingContract.beats[40],
  "habits-procrastinate-less": onboardingContract.beats[41],
  "habits-smoking": onboardingContract.beats[42],
  "habits-weed": onboardingContract.beats[43],
  "habits-alcohol": onboardingContract.beats[44],
  "habits-porn": onboardingContract.beats[45],
  "habits-phone-use": onboardingContract.beats[46],
  "habits-late-snacking": onboardingContract.beats[47],
  "habits-caffeine": onboardingContract.beats[48],
  "habits-stay-on-tasks": onboardingContract.beats[49],
  "habits-tidy-spaces": onboardingContract.beats[50],
  "habits-life-admin": onboardingContract.beats[51],
  "habit-custom": onboardingContract.beats[52],
  "schedule": onboardingContract.beats[53],
  "advanced-capture": onboardingContract.beats[54],
  "advanced-frequency": onboardingContract.beats[55],
  "plan": onboardingContract.beats[56],
  "weekly-blank": onboardingContract.beats[57],
  "weekly-full": onboardingContract.beats[58],
  "weekly-p78": onboardingContract.beats[59],
  "weekly-p36": onboardingContract.beats[60],
  "weekly-gaps": onboardingContract.beats[61],
} as const;

export const screenIdToBeatId = {
  "COACH-GREETING": "coach-greeting",
  "ONBOARD-AUTH--FORM": "sign-up",
  "MIC-PERMISSION": "mic-permission",
  "ONBOARD-01--FORM": "profile-greeting",
  "ONBOARD-01--FORM--ASKS": "profile-asks",
  "ONBOARD-STATE-CHECK": "state-check",
  "ONBOARD-MORNING-SETUP": "checkin",
  "ONBOARD-BEGINNER-07": "reflection",
  "ONBOARD-FORK--FORM": "fork",
  "ONBOARD-BEGINNER-01": "category",
  "ONBOARD-BEGINNER-02--SLEEP": "goals-sleep",
  "ONBOARD-BEGINNER-02-CUSTOM": "goal-custom",
  "ONBOARD-BEGINNER-03": "habits",
  "ONBOARD-BEGINNER-03-CUSTOM": "habit-custom",
  "ONBOARD-BEGINNER-04": "schedule",
  "ONBOARD-ADVANCED": "advanced-capture",
  "ONBOARD-ADVANCED-FREQUENCY": "advanced-frequency",
  "ONBOARD-COMPLETE": "plan",
  "ONBOARD-WEEKLY-PROJECTION-BLANK": "weekly-blank",
  "ONBOARD-WEEKLY-PROJECTION-FULL": "weekly-full",
  "ONBOARD-WEEKLY-PROJECTION-P78": "weekly-p78",
  "ONBOARD-WEEKLY-PROJECTION-P36": "weekly-p36",
  "ONBOARD-WEEKLY-PROJECTION-GAPS": "weekly-gaps"
} as const;

export const onboardingClipMap = {
  "coach_greeting": "/voice/coach_greeting.mp3",
  "mic_permission_1": "/voice/ob/mic_permission_1.wav",
  "onboard_01_form_1": "/voice/ob/onboard_01_form_1.wav",
  "onboard_01_form_2": "/voice/ob/onboard_01_form_2.wav",
  "onboard_state_check_1": "/voice/ob/onboard_state_check_1.wav",
  "state_sleep": "/voice/ob/state_sleep.wav",
  "state_mood": "/voice/ob/state_mood.wav",
  "state_energy": "/voice/ob/state_energy.wav",
  "state_stress": "/voice/ob/state_stress.wav",
  "onboard_morning_setup_1": "/voice/ob/onboard_morning_setup_1.wav",
  "onboard_morning_setup_2": "/voice/ob/onboard_morning_setup_2.wav",
  "onboard_beginner_07_1": "/voice/ob/onboard_beginner_07_1.wav",
  "reflect_proud": "/voice/ob/reflect_proud.wav",
  "reflect_forgive": "/voice/ob/reflect_forgive.wav",
  "reflect_grateful": "/voice/ob/reflect_grateful.wav",
  "reflect_alt": "/voice/ob/reflect_alt.wav",
  "reflect_time": "/voice/ob/reflect_time.wav",
  "onboard_fork_form_1": "/voice/ob/onboard_fork_form_1.wav",
  "fork_question": "/voice/ob/fork_question.wav",
  "onboard_beginner_01_1": "/voice/ob/onboard_beginner_01_1.wav",
  "create_your_own": "/voice/ob/create_your_own.wav",
  "onboard_beginner_02_sleep": "/voice/ob/onboard_beginner_02_sleep.wav",
  "onboard_beginner_02_move": "/voice/ob/onboard_beginner_02_move.wav",
  "onboard_beginner_02_eat": "/voice/ob/onboard_beginner_02_eat.wav",
  "onboard_beginner_02_energy": "/voice/ob/onboard_beginner_02_energy.wav",
  "onboard_beginner_02_stress": "/voice/ob/onboard_beginner_02_stress.wav",
  "onboard_beginner_02_focus": "/voice/ob/onboard_beginner_02_focus.wav",
  "onboard_beginner_02_break": "/voice/ob/onboard_beginner_02_break.wav",
  "onboard_beginner_02_organize": "/voice/ob/onboard_beginner_02_organize.wav",
  "onboard_beginner_02_custom_1": "/voice/ob/onboard_beginner_02_custom_1.wav",
  "onboard_beginner_03_1": "/voice/ob/onboard_beginner_03_1.wav",
  "onboard_beginner_03_goal_fall_asleep_earlier": "/voice/ob/onboard_beginner_03_goal_fall_asleep_earlier.wav",
  "onboard_beginner_03_goal_wake_earlier": "/voice/ob/onboard_beginner_03_goal_wake_earlier.wav",
  "onboard_beginner_03_goal_sleep_consistently": "/voice/ob/onboard_beginner_03_goal_sleep_consistently.wav",
  "onboard_beginner_03_goal_sleep_deeply": "/voice/ob/onboard_beginner_03_goal_sleep_deeply.wav",
  "onboard_beginner_03_goal_walk_more": "/voice/ob/onboard_beginner_03_goal_walk_more.wav",
  "onboard_beginner_03_goal_exercise_consistently": "/voice/ob/onboard_beginner_03_goal_exercise_consistently.wav",
  "onboard_beginner_03_goal_mobility": "/voice/ob/onboard_beginner_03_goal_mobility.wav",
  "onboard_beginner_03_goal_eat_intentionally": "/voice/ob/onboard_beginner_03_goal_eat_intentionally.wav",
  "onboard_beginner_03_goal_reduce_overeating": "/voice/ob/onboard_beginner_03_goal_reduce_overeating.wav",
  "onboard_beginner_03_goal_plan_food": "/voice/ob/onboard_beginner_03_goal_plan_food.wav",
  "onboard_beginner_03_goal_morning_energy": "/voice/ob/onboard_beginner_03_goal_morning_energy.wav",
  "onboard_beginner_03_goal_avoid_crashes": "/voice/ob/onboard_beginner_03_goal_avoid_crashes.wav",
  "onboard_beginner_03_goal_stable_energy": "/voice/ob/onboard_beginner_03_goal_stable_energy.wav",
  "onboard_beginner_03_goal_calmer_day": "/voice/ob/onboard_beginner_03_goal_calmer_day.wav",
  "onboard_beginner_03_goal_evening_stress": "/voice/ob/onboard_beginner_03_goal_evening_stress.wav",
  "onboard_beginner_03_goal_less_overwhelmed": "/voice/ob/onboard_beginner_03_goal_less_overwhelmed.wav",
  "onboard_beginner_03_goal_start_work": "/voice/ob/onboard_beginner_03_goal_start_work.wav",
  "onboard_beginner_03_goal_deeper_work": "/voice/ob/onboard_beginner_03_goal_deeper_work.wav",
  "onboard_beginner_03_goal_procrastinate_less": "/voice/ob/onboard_beginner_03_goal_procrastinate_less.wav",
  "onboard_beginner_03_goal_smoking": "/voice/ob/onboard_beginner_03_goal_smoking.wav",
  "onboard_beginner_03_goal_weed": "/voice/ob/onboard_beginner_03_goal_weed.wav",
  "onboard_beginner_03_goal_alcohol": "/voice/ob/onboard_beginner_03_goal_alcohol.wav",
  "onboard_beginner_03_goal_porn": "/voice/ob/onboard_beginner_03_goal_porn.wav",
  "onboard_beginner_03_goal_phone_use": "/voice/ob/onboard_beginner_03_goal_phone_use.wav",
  "onboard_beginner_03_goal_late_snacking": "/voice/ob/onboard_beginner_03_goal_late_snacking.wav",
  "onboard_beginner_03_goal_caffeine": "/voice/ob/onboard_beginner_03_goal_caffeine.wav",
  "onboard_beginner_03_goal_stay_on_tasks": "/voice/ob/onboard_beginner_03_goal_stay_on_tasks.wav",
  "onboard_beginner_03_goal_tidy_spaces": "/voice/ob/onboard_beginner_03_goal_tidy_spaces.wav",
  "onboard_beginner_03_goal_life_admin": "/voice/ob/onboard_beginner_03_goal_life_admin.wav",
  "onboard_beginner_03_custom_1": "/voice/ob/onboard_beginner_03_custom_1.wav",
  "onboard_beginner_04_1": "/voice/ob/onboard_beginner_04_1.wav",
  "onboard_beginner_04_2": "/voice/ob/onboard_beginner_04_2.wav",
  "onboard_advanced_1": "/voice/ob/onboard_advanced_1.wav",
  "close": "/voice/ob/close.wav",
  "onboard_advanced_frequency_days": "/voice/ob/onboard_advanced_frequency_days.wav",
  "onboard_advanced_frequency_1": "/voice/ob/onboard_advanced_frequency_1.wav",
  "onboard_advanced_frequency_2": "/voice/ob/onboard_advanced_frequency_2.wav",
  "onboard_complete_1": "/voice/ob/onboard_complete_1.wav",
  "onboard_weekly_projection_blank_1": "/voice/ob/onboard_weekly_projection_blank_1.wav",
  "onboard_weekly_projection_full_1": "/voice/ob/onboard_weekly_projection_full_1.wav",
  "onboard_weekly_projection_p78_1": "/voice/ob/onboard_weekly_projection_p78_1.wav",
  "onboard_weekly_projection_p36_1": "/voice/ob/onboard_weekly_projection_p36_1.wav",
  "onboard_weekly_projection_gaps_1": "/voice/ob/onboard_weekly_projection_gaps_1.wav"
} as const;

export type OnboardingContract = typeof onboardingContract;
export type OnboardingBeat = (typeof onboardingBeats)[number];
